export default {
  'IPTV服务': {
    zh: 'IPTV 服务',
    en: 'IPTV Server',
    ar: 'مجتمع IPTV',
    fa: 'سرور IPTV',
    pt: 'Servidor IPTV'
  },
  '直播频道': {
    zh: '直播频道',
    en: 'Live Channel',
    ar: 'قناة البث المباشر',
    fa: 'کانال زنده',
    pt: 'Canais ao vivo'
  },
  '请输入编号': {
    zh: '请输入编号',
    en: 'Please input number',
    ar: 'يرجى إدخال رقم',
    fa: 'لطفاً شماره را وارد کنید',
    pt: 'Por favor, insira o número'
  },
  '编号必须大于0': {
    zh: '编号必须大于0',
    en: 'Number must be greater than 0',
    ar: 'يجب أن يكون رقم أكبر من 0',
    fa: 'شماره باید بیشتر از 0 باشد',
    pt: 'O número deve ser maior que 0'
  },

  '频道审核': {
    zh: '频道审核',
    en: 'Channel Review',
    ar: 'مراجعة القناة',
    fa: 'بررسی کانال',
    pt: 'Moderação do canal'
  },
  '频道管理': {
    zh: '频道管理',
    en: 'Channel Management',
    ar: 'إدارة القناة',
    fa: 'مدیریت کانال',
    pt: 'Gestão de canais'
  },
  '显示编号排序': {
    zh: '显示编号排序',
    en: 'LCN.&Reorder',
    ar: 'ترتيب عرض الأرقام',
    fa: 'ترتیب شماره‌ها',
    pt: 'Mostrar número ordenar por'
  },
  '节目识别号': {
    zh: '节目识别号',
    en: 'Callsign',
    ar: 'رمز الاتصال',
    fa: 'کد شناسایی برنامه',
    pt: 'Número de identificação do programa'
  },
  '通过': {
    zh: '通过',
    en: 'Pass',
    ar: 'تمرير',
    fa: 'عبور',
    pt: 'Através de'
  },
  '导入频道': {
    zh: '导入频道',
    en: 'Import Channel',
    ar: 'استيراد القناة',
    fa: 'وارد کردن کانال',
    pt: 'Importação de canais'
  },
  '传输协议': {
    zh: '传输协议',
    en: 'Transfer Protocol',
    ar: 'بروتوكول النقل',
    fa: 'پروتکل انتقال',
    pt: 'Protocolo de transmissão'
  },
  '确定删除该频道吗': {
    zh: '确定删除该频道吗',
    en: 'Are you sure to delete the channel',
    ar: 'هل أنت متأكد من حذف القناة',
    fa: 'آیا مطمئن هستید که می‌خواهید کانال را حذف کنید',
    pt: 'Tenha certeza de excluir o canal'
  },
  '新增频道': {
    zh: '新增频道',
    en: 'Add Channel',
    ar: 'إضافة قناة',
    fa: 'افزودن کانال',
    pt: 'Novos canais adicionados'
  },
  '物理频道': {
    zh: '物理频道',
    en: 'Physical Channel',
    ar: 'القناة الفيزيائية',
    fa: 'کانال فیزیکی',
    pt: 'O canal físico'
  },
  '温馨提示：图片大小建议在500KB以内。': {
    zh: '温馨提示：图片大小建议在500KB以内。',
    en: 'Tips: The image size is recommended to be within 500KB.',
    ar: 'نصيحة: يُنصح بأن يكون حجم الصورة ضمن 500KB.',
    fa: 'نکته: اندازه تصویر توصیه می‌شود زیر 500KB باشد.',
    pt: 'Dicas quentes: o tamanho da imagem é recomendado dentro de 500KB.'
  },
  '节目识别号（原台标）': {
    zh: '节目识别号（原台标）',
    en: 'Callsign',
    ar: 'رمز الاتصال (الشعار الأصلي)',
    fa: 'کد شناسایی برنامه (لوگو اصلی)',
    pt: 'Número de identificação do programa (tabela original)'
  },
  '卫星转IPTV参数': {
    zh: '卫星转IPTV参数',
    en: 'Satellite to IPTV',
    ar: 'معلمات تحويل القمر الصناعي إلى IPTV',
    fa: 'پارامترهای تبدیل ماهواره به IPTV',
    pt: 'Parâmetros de transferência de satélite IPTV'
  },
  'EPG参数': {
    zh: 'EPG参数',
    en: 'EPG Parameter',
    ar: 'معلمات EPG',
    fa: 'پارامتر EPG',
    pt: 'Parâmetros do EPG'
  },
  '请选择一个SN': {
    zh: '请选择一个SN',
    en: 'Please select an SN',
    ar: 'يرجى اختيار رقم SN',
    fa: 'لطفاً یک SN انتخاب کنید',
    pt: 'Por favor, selecione um SN'
  },
  '请输入分组名称': {
    zh: '请输入分组名称',
    en: 'Please enter a group name',
    ar: 'يرجى إدخال اسم المجموعة',
    fa: 'لطفاً نام گروه را وارد کنید',
    pt: 'Por favor insira o nome do grupo'
  },
  '音频列表': {
    zh: '音频列表',
    en: 'Audio List',
    ar: 'قائمة الصوتيات',
    fa: 'فهرست صدا',
    pt: 'Lista de áudios'
  },
  '基础配置': {
    zh: '基础配置',
    en: 'Basic Configuration',
    ar: 'التكوين الأساسي',
    fa: 'پیکربندی پایه',
    pt: 'Configuração Básica'
  },
  '频道源名称': {
    zh: '频道源名称',
    en: 'Name',
    ar: 'اسم مصدر القناة',
    fa: 'نام منبع کانال',
    pt: 'Nome da fonte do canal'
  },
  '激活状态': {
    zh: '激活状态',
    en: 'Activation State',
    ar: 'حالة التنشيط',
    fa: 'وضعیت فعال‌سازی',
    pt: 'Estado da ativação'
  },
  '频道URL': {
    zh: '频道URL',
    en: 'Channel URL',
    ar: 'رابط القناة',
    fa: 'آدرس کانال',
    pt: 'URL do canal'
  },
  '爬取时间': {
    zh: '爬取时间',
    en: 'Create Time',
    ar: 'وقت الزحف',
    fa: 'زمان استخراج',
    pt: 'Escalar e pegar o tempo'
  },
  '新增物理频道': {
    zh: '新增物理频道',
    en: 'New Physical Channel',
    ar: 'إضافة قناة فيزيائية جديدة',
    fa: 'افزودن کانال فیزیکی جدید',
    pt: 'Novo canal físico'
  },
  '是否激活': {
    zh: '是否激活',
    en: 'Activate or Not',
    ar: 'تفعيل أم لا',
    fa: 'فعال کردن یا نه',
    pt: 'Ativar ou não'
  },
  '激活': {
    zh: '激活',
    en: 'Actived',
    ar: 'تم تفعيله',
    fa: 'فعال شد',
    pt: 'Activar'
  },
  '冻结': {
    zh: '冻结',
    en: 'Inactived',
    ar: 'مجمد',
    fa: 'غیر فعال',
    pt: 'Congelados'
  },
  '视频解密': {
    zh: '视频解密',
    en: 'Video Decryption',
    ar: 'فك تشفير الفيديو',
    fa: 'رمزگشایی ویدیو',
    pt: 'Descodificação de vídeo'
  },
  '审核频道': {
    zh: '审核频道',
    en: 'Review Channel',
    ar: 'مراجعة القناة',
    fa: 'بررسی کانال',
    pt: 'Moderar o canal'
  },
  '频道': {
    zh: '频道',
    en: 'Channel',
    ar: 'القناة',
    fa: 'کانال',
    pt: 'O canal'
  },
  '图片': {
    zh: '图片',
    en: 'Picture',
    ar: 'صورة',
    fa: 'تصویر',
    pt: 'Imagens'
  },
  '一级分类': {
    zh: '一级分类',
    en: 'Group Level 1',
    ar: 'المجموعة المستوى 1',
    fa: 'رده اول',
    pt: 'Classificação nível 1'
  },
  '二级分类': {
    zh: '二级分类',
    en: 'Group Level 2',
    ar: 'المجموعة المستوى 2',
    fa: 'رده دوم',
    pt: 'Classificação segundo nível'
  },
  '三级分类': {
    zh: '三级分类',
    en: 'Group Level 3',
    ar: 'المجموعة المستوى 3',
    fa: 'رده سوم',
    pt: 'Classificação em três níveis'
  },
  '四级分类': {
    zh: '四级分类',
    en: 'Group Level 4',
    ar: 'المجموعة المستوى 4',
    fa: 'رده چهارم',
    pt: 'Quatro níveis de classificação'
  },
  '编辑频道': {
    zh: '编辑频道',
    en: 'Edit Channel',
    ar: 'تحرير القناة',
    fa: 'ویرایش کانال',
    pt: 'Editar o canal'
  },
  'EPG标记': {
    zh: 'EPG标记',
    en: 'EPG Tag',
    ar: 'علامة EPG',
    fa: 'برچسب EPG',
    pt: 'Marcação do EPG'
  },
  'EPG检查': {
    zh: 'EPG检查',
    en: 'EPG Check',
    ar: 'فحص EPG',
    fa: 'بررسی EPG',
    pt: 'Inspeção do EPG'
  },
  '导入频道状态': {
    zh: '导入频道状态',
    en: 'Import Channel State',
    ar: 'استيراد حالة القناة',
    fa: 'وارد کردن وضعیت کانال',
    pt: 'Importar status do canal'
  },
  '确定将该频道修改为上线': {
    zh: '确定将该频道修改为上线',
    en: 'Are you sure to change the channel to be online',
    ar: 'هل أنت متأكد من تغيير حالة القناة إلى نشط',
    fa: 'آیا مطمئن هستید که وضعیت کانال را به آنلاین تغییر دهید',
    pt: 'Certifique-se de modificar o canal para upline'
  },
  '确定将该频道修改为下线': {
    zh: '确定将该频道修改为下线',
    en: 'Are you sure to change the channel to be offline',
    ar: 'هل أنت متأكد من تغيير حالة القناة إلى غير نشط',
    fa: 'آیا مطمئن هستید که وضعیت کانال را به آفلاین تغییر دهید',
    pt: 'Certifique-se de modificar o canal para off-line'
  },
  '确定将该频道修改为退回审核': {
    zh: '确定将该频道修改为退回审核',
    en: 'Are you sure to resume the channel for review',
    ar: 'هل أنت متأكد من إعادة القناة للمراجعة',
    fa: 'آیا مطمئن هستید که کانال را برای بررسی مجدد ارسال کنید',
    pt: 'Determine modificar este canal para rever'
  },
  '节目ID': {
    zh: '节目ID',
    en: 'Channel ID',
    ar: 'معرف القناة',
    fa: 'شناسه کانال',
    pt: 'Identificação do programa'
  },
  '节目名': {
    zh: '节目名',
    en: 'Channel Name',
    ar: 'اسم القناة',
    fa: 'نام کانال',
    pt: 'Nome do programa'
  },
  '有效天数': {
    zh: '有效天数',
    en: 'Validity Date',
    ar: 'مدة الصلاحية',
    fa: 'مدت اعتبار',
    pt: 'Dias de validade'
  },
  '正常': {
    zh: '正常',
    en: 'OK',
    ar: 'موافق',
    fa: 'اوکی',
    pt: 'Normal.'
  },
  '无数据': {
    zh: '无数据',
    en: 'No Data',
    ar: 'لا توجد بيانات',
    fa: 'داده‌ای وجود ندارد',
    pt: 'Sem dados disponíveis'
  },
  '总时长异常': {
    zh: '总时长异常',
    en: 'Duration Error',
    ar: 'خطأ في المدة',
    fa: 'خطای مدت زمان',
    pt: 'Duração total anormal'
  },
  '时间异常': {
    zh: '时间异常',
    en: 'Time Error',
    ar: 'خطأ في الوقت',
    fa: 'خطای زمان',
    pt: 'Erro de tempo'
  },
  '请勾选相同状态的频道': {
    zh: '请勾选相同状态的频道',
    en: 'Please select channels in the same state',
    ar: 'يرجى تحديد القنوات بنفس الحالة',
    fa: 'لطفاً کانال‌های با وضعیت مشابه را انتخاب کنید',
    pt: 'Por favor, marque os canais com o mesmo status'
  },
  '确认页': {
    zh: '确认页',
    en: 'Confirmation Page',
    ar: 'صفحة التأكيد',
    fa: 'صفحه تأیید',
    pt: 'Página de confirmação'
  },
  '确定将频道上线状态批量修改为': {
    zh: '确定将频道上线状态批量修改为',
    en: 'Confirm to modifiy state of channels in batch from Online to',
    ar: 'تأكيد لتعديل حالة القنوات بكميات كبيرة من نشط إلى',
    fa: 'تأیید برای تغییر وضعیت کانال‌ها به صورت دسته‌ای از آنلاین به',
    pt: 'Determine alterar o status do canal on-line em lote para'
  },
  '请勾选需要批量修改状态的频道': {
    zh: '请勾选需要批量修改状态的频道',
    en: 'Please select channels which need to be modified in batch',
    ar: 'يرجى تحديد القنوات التي تحتاج إلى تعديل الحالة بكميات كبيرة',
    fa: 'لطفاً کانال‌هایی که نیاز به تغییر وضعیت دسته‌ای دارند را انتخاب کنید',
    pt: 'Por favor, marque os canais para os quais você deseja modificar o status em massa'
  },
  '修改的频道状态需一致': {
    zh: '修改的频道状态需一致',
    en: 'The state of channels to be modified should be same',
    ar: 'يجب أن تكون حالة القنوات التي سيتم تعديلها متطابقة',
    fa: 'وضعیت کانال‌هایی که باید تغییر کند باید یکسان باشد',
    pt: 'O status do canal modificado precisa ser consistente'
  },
  '请选择至少一个频道': {
    zh: '请选择至少一个频道',
    en: 'Please select a channel',
    ar: 'يرجى تحديد قناة واحدة على الأقل',
    fa: 'لطفاً حداقل یک کانال را انتخاب کنید',
    pt: 'Por favor, selecione pelo menos um canal'
  },
  '请输入显示编号': {
    zh: '请输入显示编号',
    en: 'Please input logical channel number',
    ar: 'يرجى إدخال رقم القناة المنطقي',
    fa: 'لطفاً شماره کانال منطقی را وارد کنید',
    pt: 'Por favor, insira o número exibido'
  },
  '显示编号必须为数字': {
    zh: '显示编号必须为数字',
    en: 'Logical channel number must be a number',
    ar: 'يجب أن يكون رقم القناة المنطقي رقماً',
    fa: 'شماره کانال منطقی باید عددی باشد',
    pt: 'O número de exibição deve ser digital'
  },
  '请输入频道名称': {
    zh: '请输入频道名称',
    en: 'Please input channel name',
    ar: 'يرجى إدخال اسم القناة',
    fa: 'لطفاً نام کانال را وارد کنید',
    pt: 'Digite o nome do canal'
  },
  '请输入节目识别号': {
    zh: '请输入节目识别号',
    en: 'Please input callsign',
    ar: 'يرجى إدخال رمز التعريف',
    fa: 'لطفاً شماره شناسایی برنامه را وارد کنید',
    pt: 'Insira o número de identificação do programa'
  },
  '请选择播放等级': {
    zh: '请选择播放等级',
    en: 'Please select adult content',
    ar: 'يرجى تحديد محتوى الكبار',
    fa: 'لطفاً سطح محتوای بزرگسالان را انتخاب کنید',
    pt: 'Por favor, selecione o nível de reprodução'
  },
  '请选择': {
    zh: '请选择',
    en: 'Please select',
    ar: 'يرجى الاختيار',
    fa: 'لطفاً انتخاب کنید',
    pt: 'Por favor selecione'
  },
  '请选择需要上传的文件': {
    zh: '请选择需要上传的文件',
    en: 'Please select file to upload',
    ar: 'يرجى تحديد الملف لتحميله',
    fa: 'لطفاً فایلی را برای بارگذاری انتخاب کنید',
    pt: 'Por favor, selecione um arquivo para carregar'
  },
  '确定导入': {
    zh: '确定导入',
    en: 'Upload',
    ar: 'تحميل',
    fa: 'بارگذاری',
    pt: 'Importação'
  },
  '确定删除频道': {
    zh: '确定删除频道',
    en: 'Confirm to delete channel:',
    ar: 'تأكيد حذف القناة:',
    fa: 'تأیید برای حذف کانال:',
    pt: 'Excluir canais com certeza'
  },
  '审核不通过原因': {
    zh: '审核不通过原因',
    en: 'Failed Reason',
    ar: 'سبب الفشل',
    fa: 'علت عدم موفقیت',
    pt: 'Razões para a revisão falhar'
  },
  '审核确认页': {
    zh: '审核确认页',
    en: 'Pass Confirm',
    ar: 'تأكيد الموافقة',
    fa: 'صفحه تأیید',
    pt: 'Página de confirmação de revisão'
  },
  '确认频道通过审核': {
    zh: '确认频道通过审核',
    en: 'Confirm the channel pass review',
    ar: 'تأكيد مرور القناة بالمراجعة',
    fa: 'تأیید موفقیت کانال در بررسی',
    pt: 'Verifique se o canal foi aprovado'
  },
  '是否直接上线频道': {
    zh: '是否直接上线频道',
    en: 'Whether to go online directly',
    ar: 'هل يتم النشر مباشرة',
    fa: 'آیا باید کانال را مستقیماً آنلاین کنیم',
    pt: 'Seja direto ao canal'
  },
  '传输协议不能为空': {
    zh: '传输协议不能为空',
    en: 'Please select transfer protocol',
    ar: 'يرجى اختيار بروتوكول النقل',
    fa: 'لطفاً پروتکل انتقال را انتخاب کنید',
    pt: 'Selecione o protocolo de transferência'
  },
  '传输协议发生变化，请重新选择': {
    zh: '传输协议发生变化，请重新选择',
    en: 'Transfer protocol has changed, Please reselect',
    ar: 'تغير بروتوكول النقل، يرجى إعادة التحديد',
    fa: 'پروتکل انتقال تغییر کرده است، لطفاً دوباره انتخاب کنید',
    pt: 'O protocolo de transferência mudou. Por favor, selecione novamente'
  },
  '解码不能为空': {
    zh: '解码不能为空',
    en: 'Please select video decryption',
    ar: 'يرجى اختيار فك تشفير الفيديو',
    fa: 'لطفاً رمزگشایی ویدئو را انتخاب کنید',
    pt: 'A decodificação não pode ser vazia'
  },
  '频道编码标准，不支持该子品牌': {
    zh: '频道编码标准，不支持该子品牌',
    en: 'Channel code standard, do not support this subBrand',
    ar: 'معيار ترميز القناة، لا يدعم هذه العلامة التجارية الفرعية',
    fa: 'استاندارد کدگذاری کانال، از این زیر برند پشتیبانی نمی‌شود',
    pt: 'Padrão de codificação de canal, não suporta esta sub-marca'
  },
  '修改频道': {
    zh: '修改频道',
    en: 'Edit Channel',
    ar: 'تعديل القناة',
    fa: 'ویرایش کانال',
    pt: 'Modificar o canal'
  },
  '格式错误': {
    zh: '格式错误',
    en: 'Parameter is incorrect',
    ar: 'الوسائط غير صحيحة',
    fa: 'پارامتر نادرست است',
    pt: 'Erro no formato'
  },
  '确认是否修改成红色文字的状态吗?': {
    zh: '确认是否修改成红色文字的状态吗?',
    en: 'Confirm to change state?',
    ar: 'تأكيد تغيير الحالة؟',
    fa: 'آیا تأیید می‌کنید که وضعیت را تغییر دهید؟',
    pt: 'Confirma se alterou o estado do texto vermelho?'
  },
  '请输入不通过原因': {
    zh: '请输入不通过原因',
    en: 'Please input the reason of unpass',
    ar: 'يرجى إدخال سبب الرفض',
    fa: 'لطفاً دلیل عدم پذیرش را وارد کنید',
    pt: 'Por favor, insira o motivo da falha'
  },
  '显示编号已存在,是否继续导入': {
    zh: '显示编号已存在,是否继续导入',
    en: 'Logical Channel Number is already exist, whether continue uploading',
    ar: 'رقم القناة المنطقي موجود بالفعل، هل ترغب في متابعة التحميل؟',
    fa: 'شماره کانال منطقی قبلاً وجود دارد، آیا می‌خواهید ادامه دهید؟',
    pt: 'Mostrar número já existe, continuar a importação ou não'
  },
  '显示编号已存在': {
    zh: '显示编号已存在',
    en: 'Logical Channel Number is already exist',
    ar: 'رقم القناة المنطقي موجود بالفعل',
    fa: 'شماره کانال منطقی قبلاً وجود دارد',
    pt: 'Número de exibição já existe'
  },
  '导入的excel不应为空': {
    zh: '导入的excel不应为空',
    en: 'The imported excel should not be empty',
    ar: 'يجب أن يكون ملف excel المستورد غير فارغ',
    fa: 'فایل اکسل وارد شده نباید خالی باشد',
    pt: 'O excel importado não deve estar vazio'
  },
  '确认将选中频道下线?': {
    zh: '确认将选中频道下线?',
    en: 'Confirm to offline the channel?',
    ar: 'تأكيد إيقاف القناة المحددة؟',
    fa: 'آیا تأیید می‌کنید که کانال انتخاب شده آفلاین شود؟',
    pt: 'Confirme que o canal selecionado será desligado?'
  },
  '请输入下线原因(选填)': {
    zh: '请输入下线原因(选填)',
    en: 'Please input offline reason(optional)',
    ar: 'يرجى إدخال سبب الإيقاف (اختياري)',
    fa: 'لطفاً دلیل آفلاین شدن را وارد کنید (اختیاری)',
    pt: 'Por favor, insira o motivo do desligamento (opcional)'
  },
  '退回审核成功': {
    zh: '退回审核成功',
    en: 'Resume success',
    ar: 'استعادة النجاح',
    fa: 'بازگشت با موفقیت',
    pt: 'Retorno revisado com sucesso'
  },
  '上线成功': {
    zh: '上线成功',
    en: 'Online success',
    ar: 'النجاح على الإنترنت',
    fa: 'موفقیت آنلاین',
    pt: 'Lançamento e sucesso'
  },
  '下线成功': {
    zh: '下线成功',
    en: 'Offline success',
    ar: 'نجاح خارج الخدمة',
    fa: 'موفقیت آفلاین',
    pt: 'Desligado com sucesso'
  },
  '节目识别号已存在': {
    zh: '节目识别号已存在',
    en: 'Callsign is exist',
    ar: 'رقم التعريف موجود بالفعل',
    fa: 'شماره شناسایی برنامه قبلاً وجود دارد',
    pt: 'Número de identificação do programa já existe'
  },
  '频道图标': {
    zh: '频道图标',
    en: 'Channel Logo',
    ar: 'شعار القناة',
    fa: 'لوگوی کانال',
    pt: 'Ícone do canal'
  },
  '请选择传输协议': {
    zh: '请选择传输协议',
    en: 'Please select a transfer protocol',
    ar: 'يرجى اختيار بروتوكول النقل',
    fa: 'لطفاً پروتکل انتقال را انتخاب کنید',
    pt: 'Selecione um protocolo de transferência'
  },
  '请输入频道URL': {
    zh: '请输入频道URL',
    en: 'Please select channel url',
    ar: 'يرجى إدخال عنوان URL للقناة',
    fa: 'لطفاً URL کانال را وارد کنید',
    pt: 'Por favor insira o URL do canal'
  },
  '确认将选中频道通过审核吗': {
    zh: '确认将选中频道通过审核吗',
    en: 'Confirm to let the channel pass',
    ar: 'تأكيد السماح للقناة بالمرور',
    fa: 'آیا تأیید می‌کنید که کانال انتخاب شده تأیید شود؟',
    pt: 'Confirme que o canal selecionado será aprovado'
  },
  '直接上线频道': {
    zh: '直接上线频道',
    en: 'Online directly',
    ar: 'القناة مباشرة على الإنترنت',
    fa: 'کانال را مستقیماً آنلاین کنید',
    pt: 'Canal direto ao vivo'
  },
  '确认将选中频道下线': {
    zh: '确认将选中频道下线',
    en: 'Confirm to let the channel offline',
    ar: 'تأكيد إيقاف القناة المحددة',
    fa: 'آیا تأیید می‌کنید که کانال انتخاب شده آفلاین شود؟',
    pt: 'Confirme que o canal selecionado será desligado'
  },
  '确认是否修改成红色文字的状态': {
    zh: '确认是否修改成红色文字的状态',
    en: 'Confirm to change channel state',
    ar: 'تأكيد تغيير حالة القناة',
    fa: 'آیا تأیید می‌کنید که وضعیت کانال تغییر کند؟',
    pt: 'Confirme se o status do texto em vermelho foi alterado'
  },
  '节目识别号的长度应在1到255字符之间': {
    zh: '节目识别号的长度应在1到255字符之间',
    en: 'Callsign length must be between 1 and 255',
    ar: 'يجب أن يكون طول رقم التعريف بين 1 و 255',
    fa: 'طول شماره شناسایی برنامه باید بین 1 و 255 کاراکتر باشد',
    pt: 'O número de identificação do programa deve ter entre 1 e 255 caracteres'
  },
  '频道名称的长度应在1到255字符之间': {
    zh: '频道名称的长度应在1到255字符之间',
    en: 'Channel name length must be between 1 and 255',
    ar: 'يجب أن يتراوح طول اسم القناة بين 1 و 255',
    fa: 'طول نام کانال باید بین 1 و 255 کاراکتر باشد',
    pt: 'O nome do canal deve ter entre 1 e 255 caracteres'
  },
  '描述的长度应在1到1024字符之间': {
    zh: '描述的长度应在1到1024字符之间',
    en: 'Description length must be between 1 and 1024',
    ar: 'يجب أن يتراوح طول الوصف بين 1 و 1024',
    fa: 'طول توصیف باید بین 1 و 1024 کاراکتر باشد',
    pt: 'A descrição deve ter entre 1 e 1024 caracteres'
  },
  '请输入文件名': {
    zh: '请输入文件名',
    en: 'Please input file name',
    ar: 'يرجى إدخال اسم الملف',
    fa: 'لطفاً نام فایل را وارد کنید',
    pt: 'Por favor insira um nome'
  },
  '请输入图片URL': {
    zh: '请输入图片URL',
    en: 'Please input picture url',
    ar: 'يرجى إدخال عنوان URL للصورة',
    fa: 'لطفاً URL تصویر را وارد کنید',
    pt: 'Por favor insira o URL da imagem'
  },
  '音频格式错误': {
    zh: '音频格式错误',
    en: 'Audio list format error',
    ar: 'تنسيق قائمة الصوت غير صحيح',
    fa: 'فرمت لیست صوتی اشتباه است',
    pt: 'Formato de áudio errado'
  },
  '请输入频道源名称': {
    zh: '请输入频道源名称',
    en: 'Please input channel name',
    ar: 'يرجى إدخال اسم مصدر القناة',
    fa: 'لطفاً نام منبع کانال را وارد کنید',
    pt: 'Digite o nome da fonte do canal'
  },
  '频道源名称的长度应在1到255字符之间': {
    zh: '频道源名称的长度应在1到255字符之间',
    en: 'Name length must be between 1 and 255',
    ar: 'يجب أن يتراوح طول الاسم بين 1 و 255',
    fa: 'طول نام منبع کانال باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O nome da fonte do canal deve ter entre 1 e 255 caracteres'
  },
  '请选择是否激活': {
    zh: '请选择是否激活',
    en: 'Please select active or not active',
    ar: 'يرجى اختيار ما إذا كنت تريد تفعيل أو عدم تفعيل',
    fa: 'لطفاً انتخاب کنید که فعال باشد یا نباشد',
    pt: 'Por favor, selecione ativar ou não'
  },
  '确定删除这些频道吗': {
    zh: '确定删除这些频道吗',
    en: 'Confirm to delete these channels',
    ar: 'تأكيد حذف هذه القنوات',
    fa: 'آیا تأیید می‌کنید که این کانال‌ها حذف شوند؟',
    pt: 'Tenha certeza de excluir esses canais'
  },
  '文件名的长度应在1到255之间': {
    zh: '文件名的长度应在1到255之间',
    en: 'Name length must be between 1 and 255',
    ar: 'يجب أن يتراوح طول الاسم بين 1 و 255',
    fa: 'طول نام فایل باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O tamanho do nome do arquivo deve estar entre 1 e 255'
  },
  '下线原因': {
    zh: '下线原因',
    en: 'Offline reason',
    ar: 'سبب إيقاف الخدمة',
    fa: 'دلیل آفلاین شدن',
    pt: 'Razões para off-line'
  },
  '数据类别': {
    zh: '数据类别',
    en: 'Data Category',
    ar: 'فئة البيانات',
    fa: 'دسته‌بندی داده‌ها',
    pt: 'Categorias de dados'
  },
  '标题': {
    zh: '标题',
    en: 'Title',
    ar: 'العنوان',
    fa: 'عنوان',
    pt: 'O título'
  },
  '详情': {
    zh: '详情',
    en: 'Detail',
    ar: 'التفاصيل',
    fa: 'جزئیات',
    pt: 'pormenores'
  },
  '翻译': {
    zh: '翻译',
    en: 'Translation',
    ar: 'ترجمة',
    fa: 'ترجمه',
    pt: 'tradução'
  },
  '原始': {
    zh: '原始',
    en: 'Original',
    ar: 'أصلي',
    fa: 'اصلی',
    pt: 'O original'
  },
  '卫星参数': {
    zh: '卫星参数',
    en: 'Satellite Parameter',
    ar: 'معلمات القمر الصناعي',
    fa: 'پارامترهای ماهواره‌ای',
    pt: 'Parâmetros do satélite'
  },
  '时长(秒)': {
    zh: '时长(秒)',
    en: 'Duration(seconds)',
    ar: 'المدة (ثواني)',
    fa: 'مدت زمان (ثانیه)',
    pt: 'Duração em segundos'
  },
  '数据源': {
    zh: '数据源',
    en: 'Data Source',
    ar: 'مصدر البيانات',
    fa: 'منبع داده',
    pt: 'Fonte de dados'
  },
  '副标题': {
    zh: '副标题',
    en: 'Subtitle',
    ar: 'العنوان الفرعي',
    fa: 'زیرنویس',
    pt: 'Subtítulo título'
  },
  '年龄等级': {
    zh: '年龄等级',
    en: 'Age Level',
    ar: 'مستوى العمر',
    fa: 'سطح سنی',
    pt: 'Classificação por idade'
  },
  'DVB分类': {
    zh: 'DVB分类',
    en: 'DVB Category',
    ar: 'فئة DVB',
    fa: 'دسته‌بندی DVB',
    pt: 'Classificação em DVB'
  },
  '视频': {
    zh: '视频',
    en: 'Video',
    ar: 'فيديو',
    fa: 'ویدئو',
    pt: 'Vídeo'
  },
  '内容参数配置': {
    zh: '内容参数配置',
    en: 'Content Param Setting',
    ar: 'إعداد معلمات المحتوى',
    fa: 'تنظیمات پارامترهای محتوا',
    pt: 'Conteúdo Parâmetros'
  },
  '直播分类属性': {
    zh: '直播分类属性',
    en: 'Live Property',
    ar: 'خاصية البث المباشر',
    fa: 'ویژگی زنده',
    pt: 'Atributos Live'
  },
  '删除该分类属性，其分类属性下内容在终端将不显示，确认删除': {
    zh: '删除该分类属性，其分类属性下内容在终端将不显示，确认删除',
    en: 'Confirm to delete the category, which will not show on Terminal',
    ar: 'تأكيد حذف الفئة، التي لن تظهر على الجهاز الطرفي',
    fa: 'آیا تأیید می‌کنید که دسته‌بندی حذف شود و محتویات آن در ترمینال نمایش داده نشود؟',
    pt: 'Remova este atributo de categoria, o conteúdo sob o atributo de categoria não será exibido no terminal, confirme a exclusão'
  },
  '新增分类': {
    zh: '新增分类',
    en: 'Add Category',
    ar: 'إضافة فئة جديدة',
    fa: 'دسته‌بندی جدید اضافه کنید',
    pt: 'Novas categorias adicionadas'
  },
  '完成': {
    zh: '完成',
    en: 'Finish',
    ar: 'إنهاء',
    fa: 'پایان',
    pt: 'Terminar'
  },
  '分类属性名称的长度应在1到255字符之间': {
    zh: '分类属性名称的长度应在1到255字符之间',
    en: 'Category Property Name length must be between 1 and 255',
    ar: 'يجب أن يتراوح طول اسم خاصية الفئة بين 1 و 255',
    fa: 'طول نام ویژگی دسته‌بندی باید بین 1 و 255 کاراکتر باشد',
    pt: 'O nome do atributo de classificação deve ter entre 1 e 255 caracteres'
  },
  '同步': {
    zh: '同步',
    en: 'Synchronize',
    ar: 'مزامنة',
    fa: 'همگام‌سازی',
    pt: 'Sincronização'
  },
  '有效': {
    zh: '有效',
    en: 'Effective',
    ar: 'فعال',
    fa: 'موثر',
    pt: 'Eficaz'
  },
  '无效': {
    zh: '无效',
    en: 'Ineffective',
    ar: 'غير فعال',
    fa: 'غیر مؤثر',
    pt: 'Inválido'
  },
  '分类层级': {
    zh: '分类层级',
    en: 'Category Level',
    ar: 'مستوى التصنيف',
    fa: 'سطح دسته‌بندی',
    pt: 'Níveis de classificação'
  },
  '直播分类': {
    zh: '直播分类',
    en: 'Live Category',
    ar: 'تصنيف البث المباشر',
    fa: 'دسته‌بندی زنده',
    pt: 'Categorias ao vivo'
  },
  '确认删除分类': {
    zh: '确认删除分类',
    en: 'Confirm to delete category',
    ar: 'تأكيد حذف الفئة',
    fa: 'آیا تأیید می‌کنید که دسته‌بندی حذف شود؟',
    pt: 'Confirmar excluir categoria'
  },
  '确认删除这些分类': {
    zh: '确认删除这些分类',
    en: 'Confirm to delete these categories',
    ar: 'تأكيد حذف هذه الفئات',
    fa: 'آیا تأیید می‌کنید که این دسته‌بندی‌ها حذف شوند؟',
    pt: 'Confirmar a exclusão destas categorias'
  },
  '直播内容': {
    zh: '直播内容',
    en: 'Live Content',
    ar: 'محتوى البث المباشر',
    fa: 'محتوای زنده',
    pt: 'Conteúdo ao vivo'
  },
  '传输协议配置': {
    zh: '传输协议配置',
    en: 'Transfer Protocol Setting',
    ar: 'إعداد بروتوكول النقل',
    fa: 'تنظیمات پروتکل انتقال',
    pt: 'Configuração do protocolo de transporte'
  },
  '视频解密设置': {
    zh: '视频解密设置',
    en: 'Video Decryption Setting',
    ar: 'إعداد فك تشفير الفيديو',
    fa: 'تنظیمات رمزگشایی ویدئو',
    pt: 'Configurações de descriptografia de vídeo'
  },
  '确认移除频道': {
    zh: '确认移除频道',
    en: 'Confirm to remove channel',
    ar: 'تأكيد إزالة القناة',
    fa: 'آیا تأیید می‌کنید که کانال حذف شود؟',
    pt: 'Confirme a remoção do canal'
  },
  '直播参数': {
    zh: '直播参数',
    en: 'Live Params',
    ar: 'معلمات البث المباشر',
    fa: 'پارامترهای زنده',
    pt: 'Parâmetros ao vivo'
  },
  '卫星转IPTV屏蔽卫星参数设置': {
    zh: '卫星转IPTV屏蔽卫星参数设置',
    en: 'Satellite to IPTV Block Params Setting',
    ar: 'إعدادات معلمات حظر الأقمار الصناعية إلى IPTV',
    fa: 'تنظیمات پارامترهای مسدود کردن ماهواره به IPTV',
    pt: 'Satélite para IPTV bloqueando configurações de parâmetros de satélite'
  },
  '卫星角度': {
    zh: '卫星角度',
    en: 'Satellite Angle',
    ar: 'زاوية القمر الصناعي',
    fa: 'زاویه ماهواره',
    pt: 'Ângulo do satélite'
  },
  '视频解密参数设置': {
    zh: '视频解密参数设置',
    en: 'Video Decryption Parameters Setting',
    ar: 'إعدادات معلمات فك تشفير الفيديو',
    fa: 'تنظیمات پارامترهای رمزگشایی ویدئو',
    pt: 'Configuração de parâmetros de descriptografia de vídeo'
  },
  '视频解密key': {
    zh: '视频解密key',
    en: 'Video Decryption Key',
    ar: 'مفتاح فك تشفير الفيديو',
    fa: 'کلید رمزگشایی ویدئو',
    pt: 'Chave de descriptografia de vídeo'
  },
  '多个卫星用 ; 间隔': {
    zh: '多个卫星用 ; 间隔',
    en: 'Use ; to separate several satellites',
    ar: 'استخدم ; لفصل عدة أقمار صناعية',
    fa: 'برای جدا کردن چندین ماهواره از ; استفاده کنید',
    pt: 'Use ; para separar vários satélites'
  },
  '请输入key': {
    zh: '请输入key',
    en: 'Please input key',
    ar: 'يرجى إدخال المفتاح',
    fa: 'لطفاً کلید را وارد کنید',
    pt: 'Por favor insira a chave'
  },
  '修改分类': {
    zh: '修改分类',
    en: 'Edit Category',
    ar: 'تعديل الفئة',
    fa: 'ویرایش دسته‌بندی',
    pt: 'Modificar classificação'
  },
  '需将分类中的内容清空再删除': {
    zh: '需将分类中的内容清空再删除',
    en: 'Please clear and delete the contents in the category',
    ar: 'يرجى مسح وحذف المحتويات في الفئة',
    fa: 'لطفاً محتویات دسته‌بندی را پاک کنید و سپس حذف کنید',
    pt: 'É necessário limpar o conteúdo da categoria e depois excluí-lo'
  },
  '频道不支持该协议': {
    zh: '频道不支持该协议',
    en: 'Channel does not support this protocol',
    ar: 'القناة لا تدعم هذا البروتوكول',
    fa: 'کانال از این پروتکل پشتیبانی نمی‌کند',
    pt: 'O canal não suporta este protocolo'
  },
  '物理频道名称不能为空': {
    zh: '物理频道名称不能为空',
    en: 'Please input physical channel name',
    ar: 'يرجى إدخال اسم القناة الفعلي',
    fa: 'لطفاً نام کانال فیزیکی را وارد کنید',
    pt: 'O nome do canal físico não pode ficar vazio'
  },
  '分类已绑定内容，需将分类中的内容清空再编辑': {
    zh: '分类已绑定内容，需将分类中的内容清空再编辑',
    en: 'Category had bound content, please clear the content first',
    ar: 'الفئة تحتوي على محتوى مربوط، يرجى مسح المحتوى أولاً',
    fa: 'دسته‌بندی دارای محتوای متصل است، لطفاً ابتدا محتویات را پاک کنید',
    pt: 'A categoria tem conteúdo vinculado. Você precisa limpar o conteúdo da categoria antes de editá-la.'
  },
  '分类属性名称已存在': {
    zh: '分类属性名称已存在',
    en: 'Category property name already exists',
    ar: 'اسم خاصية الفئة موجود بالفعل',
    fa: 'نام ویژگی دسته‌بندی قبلاً وجود دارد',
    pt: 'O nome do atributo de classificação já existe'
  },
  '请至少选择一个分类': {
    zh: '请至少选择一个分类',
    en: 'Please select at least one category',
    ar: 'يرجى اختيار فئة واحدة على الأقل',
    fa: 'لطفاً حداقل یک دسته‌بندی را انتخاب کنید',
    pt: 'Selecione pelo menos uma categoria'
  },
  '不能删除已上线的频道': {
    zh: '不能删除已上线的频道',
    en: 'Cannot delete the online channel',
    ar: 'لا يمكن حذف القناة المتصلة',
    fa: 'کانال آنلاین را نمی‌توان حذف کرد',
    pt: 'Canais online não podem ser excluídos'
  },
  '播放失败,请刷新重试': {
    zh: '播放失败,请刷新重试',
    en: 'Play error, please refresh and retry',
    ar: 'فشل التشغيل، يرجى التحديث وإعادة المحاولة',
    fa: 'پخش با خطا مواجه شد، لطفاً صفحه را بروزرسانی کرده و دوباره تلاش کنید',
    pt: 'Falha na reprodução. Atualize e tente novamente'
  },
  '请使用vlc播放器播放该视频': {
    zh: '请使用vlc播放器播放该视频',
    en: 'Please use VLC Player to play this video',
    ar: 'يرجى استخدام مشغل VLC لتشغيل هذا الفيديو',
    fa: 'لطفاً از پلیر VLC برای پخش این ویدئو استفاده کنید',
    pt: 'Use o player VLC para reproduzir este vídeo'
  },
  '暂不支持播放该类型视频': {
    zh: '暂不支持播放该类型视频',
    en: 'This type of video is not supported',
    ar: 'لا يدعم تشغيل هذا النوع من الفيديو',
    fa: 'این نوع ویدئو در حال حاضر پشتیبانی نمی‌شود',
    pt: 'A reprodução deste tipo de vídeo não é suportada no momento'
  },
  '输入内容': {
    zh: '输入内容',
    en: 'Please input',
    ar: 'يرجى الإدخال',
    fa: 'لطفاً محتویات را وارد کنید',
    pt: 'Insira o conteúdo'
  },
  '确定重新给显示编号排序吗': {
    zh: '确定重新给显示编号排序吗',
    en: 'Are you sure to re-sort the logical channel number',
    ar: 'هل أنت متأكد من إعادة ترتيب أرقام القنوات المنطقية؟',
    fa: 'آیا مطمئن هستید که شماره‌های کانال منطقی را دوباره مرتب کنید؟',
    pt: 'Tem certeza de que deseja reordenar os números de exibição?'
  },
  '确定将该频道设为终端审核': {
    zh: '确定将该频道设为终端审核',
    en: 'Make sure to set the channel to terminal review',
    ar: 'تأكد من تعيين القناة للمراجعة النهائية',
    fa: 'آیا تأیید می‌کنید که کانال را به بررسی نهایی اختصاص دهید؟',
    pt: 'Confirme para definir este canal para moderação de terminal'
  },
  '审核确认': {
    zh: '审核确认',
    en: 'Review and confirm',
    ar: 'مراجعة وتأكيد',
    fa: 'بازبینی و تأیید',
    pt: 'Confirmar revisão'
  },
  '请至少选择一个频道': {
    zh: '请至少选择一个频道',
    en: 'Please select at least one channel',
    ar: 'يرجى اختيار قناة واحدة على الأقل',
    fa: 'لطفاً حداقل یک کانال را انتخاب کنید',
    pt: 'Selecione pelo menos um canal'
  },
  '编辑分类': {
    zh: '编辑分类',
    en: 'Edit Category',
    ar: 'تحرير الفئة',
    fa: 'ویرایش دسته‌بندی',
    pt: 'Editar categoria'
  },
  '请选择上级分类': {
    zh: '请选择上级分类',
    en: 'Please select an upper-level category',
    ar: 'يرجى اختيار فئة من المستوى الأعلى',
    fa: 'لطفاً دسته‌بندی بالادستی را انتخاب کنید',
    pt: 'Selecione a categoria de nível superior'
  },
  '分类下存在子分类,请先删除子分类': {
    zh: '分类下存在子分类,请先删除子分类',
    en: 'A category has subcategories. Delete the subcategories first',
    ar: 'تحت الفئة توجد فئات فرعية، يرجى حذف الفئات الفرعية أولاً',
    fa: 'در زیر دسته‌بندی، زیرمجموعه‌ها وجود دارد. لطفاً ابتدا زیرمجموعه‌ها را حذف کنید',
    pt: 'Existem subcategorias na categoria, exclua as subcategorias primeiro'
  },
  '视频解密配置': {
    zh: '视频解密配置',
    en: 'Video Decryption Setting',
    ar: 'إعداد فك تشفير الفيديو',
    fa: 'تنظیمات رمزگشایی ویدئو',
    pt: 'Configuração de descriptografia de vídeo'
  },
  '暂无数据': {
    zh: '暂无数据',
    en: 'No Data',
    ar: 'لا توجد بيانات',
    fa: 'داده‌ای موجود نیست',
    pt: 'Sem dados'
  },
  '确认移除这些频道': {
    zh: '确认移除这些频道',
    en: 'Confirm to delete these channels',
    ar: 'تأكيد حذف هذه القنوات',
    fa: 'آیا تأیید می‌کنید که این کانال‌ها حذف شوند؟',
    pt: 'Confirme a remoção destes canais'
  },
  '服务器参数': {
    zh: '服务器参数',
    en: 'Server Parameter',
    ar: 'معلمات الخادم',
    fa: 'پارامترهای سرور',
    pt: 'Parâmetros do servidor'
  },
  '服务器参数设置': {
    zh: '服务器参数设置',
    en: 'Server Parameter Setting',
    ar: 'إعدادات معلمات الخادم',
    fa: 'تنظیمات پارامترهای سرور',
    pt: 'Configuração de parâmetros do servidor'
  },
  '服务器地址': {
    zh: '服务器地址',
    en: 'Server Address',
    ar: 'عنوان الخادم',
    fa: 'آدرس سرور',
    pt: 'Endereço do servidor'
  },
  '主地址': {
    zh: '主地址',
    en: 'Main Address',
    ar: 'العنوان الرئيسي',
    fa: 'آدرس اصلی',
    pt: 'Endereço principal'
  },
  '服务器名称': {
    zh: '服务器名称',
    en: 'Server Name',
    ar: 'اسم الخادم',
    fa: 'نام سرور',
    pt: 'Nome do Servidor'
  },
  '服务器状态': {
    zh: '服务器状态',
    en: 'Server Status',
    ar: 'حالة الخادم',
    fa: 'وضع سرور',
    pt: 'Status do servidor'
  },
  '确定删除该服务器': {
    zh: '确定删除该服务器',
    en: 'Confirm to delete the server',
    ar: 'تأكيد حذف الخادم',
    fa: 'آیا تأیید می‌کنید که این سرور حذف شود؟',
    pt: 'Confirme para excluir este servidor'
  },
  '选择子品牌及分类': {
    zh: '选择子品牌及分类',
    en: 'Select sub-brands and categories',
    ar: 'اختر العلامات التجارية الفرعية والفئات',
    fa: 'زیر برندها و دسته‌بندی‌ها را انتخاب کنید',
    pt: 'Selecione submarca e categoria'
  },
  '请输入服务器名称': {
    zh: '请输入服务器名称',
    en: 'Please input server name',
    ar: 'يرجى إدخال اسم الخادم',
    fa: 'لطفاً نام سرور را وارد کنید',
    pt: 'Por favor insira o nome do servidor'
  },
  '服务器名称的长度应在1到255字符之间': {
    zh: '服务器名称的长度应在1到255字符之间',
    en: 'Server name length must be between 1 and 255',
    ar: 'يجب أن يتراوح طول الاسم بين 1 و255 حرفًا',
    fa: 'طول نام سرور باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O nome do servidor deve ter entre 1 e 255 caracteres'
  },
  '切换 PID-CID-MID': {
    zh: '切换 PID-CID-MID',
    en: 'Switch PID-CID-MID',
    ar: 'تبديل PID-CID-MID',
    fa: 'تغییر PID-CID-MID',
    pt: 'Alternar PID-CID-MID'
  },
  '切换': {
    zh: '切换',
    en: 'Switch',
    ar: 'تبديل',
    fa: 'تغییر',
    pt: 'Alternar'
  },
  '确定恢复该SN': {
    zh: '确定恢复该SN',
    en: 'Confirm to renew this SN',
    ar: 'تأكيد تجديد هذا SN',
    fa: 'آیا تأیید می‌کنید که این SN بازیابی شود؟',
    pt: 'Confirme para restaurar o SN'
  },
  '一个传输协议只能设置一个主地址': {
    zh: '一个传输协议只能设置一个主地址',
    en: 'A protocol can only set one primary address',
    ar: 'يمكن لبروتوكول واحد فقط تعيين عنوان رئيسي واحد',
    fa: 'یک پروتکل فقط می‌تواند یک آدرس اصلی تنظیم کند',
    pt: 'Apenas um endereço primário pode ser definido para um protocolo de transporte'
  },
  '删除后该SN的PID-CID-MID将恢复修改前的PID-CID-MID,确定要删除吗': {
    zh: '删除后该SN的PID-CID-MID将恢复修改前的PID-CID-MID,确定要删除吗',
    en: 'After the PID-CID-MID of the SN is deleted, the PID-CID-MID of the SN is restored to that before the change. Are you sure to delete it',
    ar: 'بعد حذف PID-CID-MID الخاص بـ SN، سيتم استعادة PID-CID-MID إلى ما كان عليه قبل التغيير. هل أنت متأكد من أنك تريد حذفه؟',
    fa: 'پس از حذف PID-CID-MID SN، PID-CID-MID به حالت قبلی قبل از تغییر برمی‌گردد. آیا مطمئن هستید که می‌خواهید آن را حذف کنید؟',
    pt: 'Após a exclusão, o PID-CID-MID do SN será restaurado para o PID-CID-MID antes da modificação. Tem certeza de que deseja excluí-lo?'
  },
  '请输入SN': {
    zh: '请输入SN',
    en: 'Please input SN',
    ar: 'يرجى إدخال SN',
    fa: 'لطفاً SN را وارد کنید',
    pt: 'Por favor insira SN'
  },
  'SN的长度应在1到1024字符之间': {
    zh: 'SN的长度应在1到1024字符之间',
    en: 'SN length must be between 1 and 1024',
    ar: 'يجب أن يتراوح طول SN بين 1 و1024 حرفًا',
    fa: 'طول SN باید بین 1 تا 1024 کاراکتر باشد',
    pt: 'O comprimento do SN deve estar entre 1 e 1024 caracteres'
  },
  '视频解密key长度应在8-24位': {
    zh: '视频解密key长度应在8-24位',
    en: 'Video Decryption Key length must be between 8 and 24',
    ar: 'يجب أن يتراوح طول مفتاح فك تشفير الفيديو بين 8 و24',
    fa: 'طول کلید رمزگشایی ویدئو باید بین 8 تا 24 کاراکتر باشد',
    pt: 'O comprimento da chave de descriptografia de vídeo deve ser de 8 a 24 bits'
  },
  '物理频道激活后会呈现在终端，确认激活吗': {
    zh: '物理频道激活后会呈现在终端，确认激活吗',
    en: 'After the physical channel is activated, it will be displayed on the terminal. Do you confirm the activation',
    ar: 'بعد تفعيل القناة الفيزيائية، ستظهر على الجهاز. هل تؤكد التفعيل؟',
    fa: 'پس از فعال‌سازی کانال فیزیکی، در ترمینال نمایش داده خواهد شد. آیا تأیید می‌کنید که فعال‌سازی انجام شود؟',
    pt: 'Após a ativação do canal físico, ele será exibido no terminal, você confirma a ativação?'
  },
  '排序优先级为公共频道、国家、分类属性': {
    zh: '排序优先级为公共频道、国家、分类属性',
    en: 'Sorting priority is public channel, country, classification attribute',
    ar: 'أولوية الترتيب هي القناة العامة، الدولة، سمة التصنيف',
    fa: 'اولویت ترتیب به ترتیب کانال عمومی، کشور، ویژگی دسته‌بندی است',
    pt: 'A prioridade de classificação é canal público, país, atributo de classificação'
  },
  '操作后频道会按名称字母重新排序，确认操作吗': {
    zh: '操作后频道会按名称字母重新排序，确认操作吗',
    en: 'Are you sure to sort all channels by name alphabetically?',
    ar: 'هل أنت متأكد من أنك تريد ترتيب جميع القنوات حسب الاسم أبجديًا؟',
    fa: 'آیا مطمئن هستید که می‌خواهید تمام کانال‌ها را به ترتیب حروف الفبا مرتب کنید؟',
    pt: 'Após a operação, os canais serão reordenados em ordem alfabética por nome. Confirma a operação?'
  },
  '跳转到审核': {
    zh: '跳转到审核',
    en: 'Skip To Audit',
    ar: 'الانتقال إلى التدقيق',
    fa: 'انتقال به بررسی',
    pt: 'Ir para revisão'
  },
  '频道关联分类未设置传输协议': {
    zh: '频道关联分类未设置传输协议',
    en: 'The channel association category has not set the transfer protocol',
    ar: 'فئة ارتباط القناة لم تقم بتعيين بروتوكول النقل',
    fa: 'دسته‌بندی ارتباط کانال پروتکل انتقال را تنظیم نکرده است',
    pt: 'A classificação de associação de canal não possui protocolo de transporte definido'
  },
  '确定冻结该物理频道吗': {
    zh: '确定冻结该物理频道吗',
    en: 'Confirm to freeze the physical channel',
    ar: 'تأكيد تجميد القناة الفيزيائية',
    fa: 'آیا تأیید می‌کنید که این کانال فیزیکی فریز شود؟',
    pt: 'Tem certeza de que deseja congelar este canal físico?'
  },
  '确认将频道移除子品牌，移除后频道关联子品牌的其他分类也会将频道移除': {
    zh: '确认将频道移除子品牌，移除后频道关联子品牌的其他分类也会将频道移除',
    en: 'Confirm that the channel is removed from the subbrand. After the channel is removed, other categories associated with the subbrand will also remove the channel',
    ar: 'تأكيد إزالة القناة من العلامة التجارية الفرعية. بعد إزالة القناة، ستتم إزالة القناة أيضًا من الفئات الأخرى المرتبطة بالعلامة التجارية الفرعية',
    fa: 'آیا تأیید می‌کنید که این کانال از زیر برند حذف شود؟ پس از حذف، سایر دسته‌بندی‌های مرتبط با زیر برند نیز کانال را حذف خواهند کرد.',
    pt: 'Confirme a remoção da submarca do canal. Após a remoção, outras categorias de submarcas associadas ao canal também removerão o canal.'
  },
  'url不能为空': {
    zh: 'url不能为空',
    en: 'The url can not be null',
    ar: 'الـ URL لا يمكن أن يكون فارغًا',
    fa: 'URL نمی‌تواند خالی باشد',
    pt: 'Url não pode ficar vazio'
  },
  '盒子离线': {
    zh: '盒子离线',
    en: 'Device Offline',
    ar: 'الجهاز غير متصل',
    fa: 'دستگاه آفلاین است',
    pt: 'Caixa off-line'
  },
  '请选择Server Type': {
    zh: '请选择Server Type',
    en: 'Please select Server Type',
    ar: 'يرجى تحديد نوع الخادم',
    fa: 'لطفاً نوع سرور را انتخاب کنید',
    pt: 'Selecione um tipo de servidor'
  },
  '请输入Host': {
    zh: '请输入Host',
    en: 'Please enter Host',
    ar: 'يرجى إدخال المضيف',
    fa: 'لطفاً میزبان را وارد کنید',
    pt: 'Por favor insira Host'
  },
  'Host的长度应在1到100字符之间': {
    zh: 'Host的长度应在1到100字符之间',
    en: 'The length of Host should be between 1 and 100 characters',
    ar: 'يجب أن يتراوح طول المضيف بين 1 و100 حرف',
    fa: 'طول میزبان باید بین 1 تا 100 کاراکتر باشد',
    pt: 'O Host deve ter entre 1 e 100 caracteres'
  },
  'SN的长度应在1到50字符之间': {
    zh: 'SN的长度应在1到50字符之间',
    en: 'The length of the SN should be between 1 and 50 characters',
    ar: 'يجب أن يتراوح طول SN بين 1 و50 حرفًا',
    fa: 'طول SN باید بین 1 تا 50 کاراکتر باشد',
    pt: 'SN deve ter entre 1 e 50 caracteres'
  },
  '请输入Port': {
    zh: '请输入Port',
    en: 'Please enter Port',
    ar: 'يرجى إدخال المنفذ',
    fa: 'لطفاً پورت را وارد کنید',
    pt: 'Por favor insira o porto'
  },
  'Port的长度应在1到50字符之间': {
    zh: 'Port的长度应在1到50字符之间',
    en: 'The length of the Port should be between 1 and 50 characters',
    ar: 'يجب أن يتراوح طول المنفذ بين 1 و50 حرفًا',
    fa: 'طول پورت باید بین 1 تا 50 کاراکتر باشد',
    pt: 'A porta deve ter entre 1 e 50 caracteres'
  },
  '请输入User Name': {
    zh: '请输入User Name',
    en: 'Please enter User Name',
    ar: 'يرجى إدخال اسم المستخدم',
    fa: 'لطفاً نام کاربری را وارد کنید',
    pt: 'Por favor insira um nome de usuário'
  },
  'User Name的长度应在1到100字符之间': {
    zh: 'User Name的长度应在1到100字符之间',
    en: 'The length of the User Name should be between 1 and 100 characters',
    ar: 'يجب أن يتراوح طول اسم المستخدم بين 1 و100 حرف',
    fa: 'طول نام کاربری باید بین 1 تا 100 کاراکتر باشد',
    pt: 'Nome de usuário deve ter entre 1 e 100 caracteres'
  },
  '请输入Password': {
    zh: '请输入Password',
    en: 'Please enter Password',
    ar: 'يرجى إدخال كلمة المرور',
    fa: 'لطفاً رمز عبور را وارد کنید',
    pt: 'Digite a senha'
  },
  'Password的长度应在1到100字符之间': {
    zh: 'Password的长度应在1到100字符之间',
    en: 'The length of the Password should be between 1 and 100 characters',
    ar: 'يجب أن يتراوح طول كلمة المرور بين 1 و100 حرف',
    fa: 'طول رمز عبور باید بین 1 تا 100 کاراکتر باشد',
    pt: 'A senha deve ter entre 1 e 100 caracteres'
  },
  '请输入Des Key': {
    zh: '请输入Des Key',
    en: 'Please enter Des Key',
    ar: 'يرجى إدخال مفتاح Des',
    fa: 'لطفاً کلید Des را وارد کنید',
    pt: 'Digite a chave Des'
  },
  'Des Key的长度应在1到100字符之间': {
    zh: 'Des Key的长度应在1到100字符之间',
    en: 'The length of the Des Key should be between 1 and 100 characters',
    ar: 'يجب أن يتراوح طول مفتاح Des بين 1 و100 حرف',
    fa: 'طول کلید Des باید بین 1 تا 100 کاراکتر باشد',
    pt: 'Des Key deve ter entre 1 e 100 caracteres'
  },
  '操作人': {
    zh: '操作人',
    en: 'Operator',
    ar: 'المشغل',
    fa: 'اپراتور',
    pt: 'O operador'
  },
  '增加': {
    zh: '增加',
    en: 'Add',
    ar: 'إضافة',
    fa: 'افزودن',
    pt: 'aumentar'
  },
  '确认要删除该条信息': {
    zh: '确认要删除该条信息',
    en: 'Confirm that you want to delete this message',
    ar: 'تأكيد أنك تريد حذف هذه الرسالة',
    fa: 'آیا تأیید می‌کنید که می‌خواهید این پیام را حذف کنید؟',
    pt: 'Confirme que deseja remover esta mensagem'
  },
  '确认要删除这些信息': {
    zh: '确认要删除这些信息',
    en: 'Confirm that you want to delete these messages',
    ar: 'تأكيد أنك تريد حذف هذه الرسائل',
    fa: 'آیا تأیید می‌کنید که می‌خواهید این پیام‌ها را حذف کنید؟',
    pt: 'Confirme que deseja excluir essas informações'
  },
  '最多添加十组配置': {
    zh: '最多添加十组配置',
    en: 'A maximum of ten configuration groups can be added',
    ar: 'يمكن إضافة ما يصل إلى عشرة مجموعات تكوين',
    fa: 'حداکثر می‌توانید ده گروه پیکربندی اضافه کنید',
    pt: 'Adicionar até dez grupos de configurações'
  },
  '配置已重复，请修改后提交': {
    zh: '配置已重复，请修改后提交',
    en: 'The configuration is repeated. Please modify it and submit it',
    ar: 'التكوين مكرر. يرجى تعديله ثم تقديمه',
    fa: 'پیکربندی تکراری است. لطفاً آن را اصلاح کرده و ارسال کنید',
    pt: 'A configuração foi duplicada, por favor, corrija e envie'
  },
  'Mgcam/CCCam(reseller)': {
    zh: 'Mgcam/CCCam',
    en: 'Mgcam/CCCam',
    ar: 'Mgcam/CCCam',
    fa: 'Mgcam/CCCam',
    pt: 'Mgcam/CCCam'
  },
  'Mgcam/CCCam(admin)': {
    zh: 'Mgcam/CCCam',
    en: 'Mgcam/CCCam',
    ar: 'Mgcam/CCCam',
    fa: 'Mgcam/CCCam',
    pt: 'Mgcam/CCCam'
  },
  'PDASH配置': {
    zh: 'PDASH配置',
    en: 'PDASH Config',
    ar: 'تكوين PDASH',
    fa: 'پیکربندی PDASH',
    pt: 'Configuração PDASH'
  },
  '请勿重复添加数据(PID、CID)': {
    zh: '请勿重复添加数据(PID、CID)',
    en: 'Do not add data (PID, CID) repeatedly',
    ar: 'لا تقم بإضافة البيانات بشكل متكرر (PID، CID)',
    fa: 'داده ها را به طور مکرر اضافه نکنید (PID، CID)',
    pt: 'Não adicione dados repetidamente (PID, CID)'
  },
  '平台(PID)': {
    zh: '平台(PID)',
    en: 'Platform (PID)',
    ar: 'منصة (PID)',
    fa: 'پلتفرم (PID)',
    pt: 'Plataforma (PID)'
  },
  '品牌(CID)': {
    zh: '品牌(CID)',
    en: 'Brand (CID)',
    ar: 'العلامة التجارية (CID)',
    fa: 'نام تجاری (CID)',
    pt: 'Marca (CID)'
  },
  '型号(MID)': {
    zh: '型号(MID)',
    en: 'Model (MID)',
    ar: 'النموذج (المتوسط)',
    fa: 'مدل (MID)',
    pt: 'Modelo (MID)'
  },
  '发布比例(%)': {
    zh: '发布比例(%)',
    en: 'Release percent(%)',
    ar: 'Release percent(%)',
    fa: 'Release percent(%)',
    pt: 'Release percent(%)'
  },
  '请输入0-100的整数': {
    zh: '请输入0-100的整数',
    en: 'Please enter an integer between 0 and 100',
    ar: 'الرجاء إدخال عدد صحيح من 0 إلى 100',
    fa: 'لطفا یک عدد صحیح از 0 تا 100 وارد کنید',
    pt: 'Introduza um número inteiro de 0 a 100'
  },
  '请选择型号': {
    zh: '请选择型号',
    en: 'Please select model',
    ar: 'الرجاء تحديد النموذج',
    fa: 'لطفا مدل را انتخاب کنید',
    pt: 'Selecione o modelo'
  },
  '7天': {
    zh: '7天',
    en: '7 Days',
    ar: '7 أيام',
    fa: '7 روز',
    pt: '7 dias'
  },
  '30天': {
    zh: '30天',
    en: '30 Days',
    ar: '30 يوما',
    fa: '30 روز',
    pt: '30 dias'
  },
  '14天': {
    zh: '14天',
    en: '14 Days',
    ar: '14 يوما',
    fa: '14 روز',
    pt: '14 dias'
  },
  '存在执行中的运营计划，不允许删除': {
    zh: '存在执行中的运营计划，不允许删除',
    en: 'There is an operational plan in execution, deletion is not allowed',
    ar: 'هناك خطة تشغيلية قيد التنفيذ ولا يسمح بحذفها.',
    fa: 'برنامه عملیاتی در اجرا وجود دارد و حذف مجاز نیست.',
    pt: 'Existe um plano operacional em execução e a sua eliminação não é permitida.'
  },
  '方案运行中，不可删除': {
    zh: '方案运行中，不可删除',
    en: 'The plan is running and cannot be deleted.',
    ar: 'الخطة قيد التشغيل ولا يمكن حذفها.',
    fa: 'طرح در حال اجرا است و قابل حذف نیست.',
    pt: 'O plano está em execução e não pode ser eliminado.'
  },
  '该推荐位执行中，不允许删除': {
    zh: '该推荐位执行中，不允许删除',
    en: 'This recommendation is in progress and cannot be deleted.',
    ar: 'يتم تنفيذ بت التوصية ولا يُسمح بحذفه.',
    fa: 'بیت توصیه در حال اجرا است و اجازه حذف ندارد.',
    pt: 'O bit de recomendação está a ser executado e não pode ser eliminado.'
  },
  '云盘账号': {
    zh: '云盘账号',
    en: 'Cloud Disk Account',
    ar: 'حساب القرص السحابي',
    fa: 'حساب دیسک ابری',
    pt: 'Conta de disco na nuvem'
  },
  '关联网盘': {
    zh: '关联网盘',
    en: 'Associated Cloud Disk',
    ar: 'القرص السحابي المرتبط',
    fa: 'دیسک ابری مرتبط',
    pt: 'Disco de nuvem associado'
  },
  '批量关联云盘': {
    zh: '批量关联云盘',
    en: 'Batch Linking Cloud Disks',
    ar: 'ربط الأقراص السحابية على دفعات',
    fa: 'دیسک های ابری را به صورت دسته ای مرتبط کنید',
    pt: 'Associe discos na nuvem em lotes'
  },
  '先勾选需要批量操作的影片': {
    zh: '先勾选需要批量操作的影片',
    en: 'First select the videos that need to be batch operated',
    ar: 'حدد أولاً مقاطع الفيديو التي تحتاج إلى عملية دفعية',
    fa: 'ابتدا ویدیوهایی را که نیاز به عملیات دسته جمعی دارند انتخاب کنید',
    pt: 'Primeiro selecione os vídeos que necessitam de operação em batch'
  },
  '关联云盘': {
    zh: '关联云盘',
    en: 'Associated Cloud Disk',
    ar: 'القرص السحابي المرتبط',
    fa: 'دیسک ابری مرتبط',
    pt: 'Disco de nuvem associado'
  },
  '不关联': {
    zh: '不关联',
    en: 'Not Related',
    ar: 'غير ذات صلة',
    fa: 'مرتبط نیست',
    pt: 'Não relevante'
  },
  '选择云盘': {
    zh: '选择云盘',
    en: 'Select Cloud Disk',
    ar: 'حدد القرص السحابي',
    fa: 'دیسک ابری را انتخاب کنید',
    pt: 'Selecione o disco da nuvem'
  },
  // '增加': {
  //   zh: '增加',
  //   en: 'Add',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  'NetAudio 3Id 映射': {
    zh: 'NetAudio 3Id 映射',
    en: 'NetAudio 3Id Mapping',
    ar: 'خرائط NetAudio 3Id',
    fa: 'نگاشت NetAudio 3Id',
    pt: 'Mapeamento NetAudio 3Id'
  },
  '原CID-PID-MID': {
    zh: '原CID-PID-MID',
    en: 'Original CID-PID-MID',
    ar: 'CID-PID-MID الأصلي',
    fa: 'CID-PID-MID اصلی',
    pt: 'CID-PID-MID Original'
  },
  '映射CID-PID-MID': {
    zh: '映射CID-PID-MID',
    en: 'Mapped CID-PID-MID',
    ar: 'CID-PID-MID المعروض',
    fa: 'نگاشت CID-PID-MID',
    pt: 'CID-PID-MID Mapeado'
  },
  '是否删除该映射': {
    zh: '是否删除该映射',
    en: 'Delete this mapping?',
    ar: 'هل حذف هذه الخريطة؟',
    fa: 'آیا این نگاشت را حذف کنید؟',
    pt: 'Excluir este mapeamento?'
  },
  '影片推荐': {
    zh: '影片推荐',
    en: 'Movie Recommend',
    ar: 'فيلم موصى به',
    fa: 'توصیه فیلم',
    pt: 'filme recomendado'
  },
  '分类推荐': {
    zh: '分类推荐',
    en: 'Category Recommend',
    ar: 'الفئة الموصى بها',
    fa: 'دسته توصیه می کنند',
    pt: 'categoria recomendada'
  },
  '待爬取': {
    zh: '待爬取',
    en: 'Not Crawled',
    ar: 'لم يتم الزحف',
    fa: 'خزیده نشده است',
    pt: 'Não rastreado'
  },
  '爬取异常': {
    zh: '爬取异常',
    en: 'Crawled Error',
    ar: 'خطأ الزحف',
    fa: 'خطای خزیدن',
    pt: 'Erro de rastreamento'
  },
  '爬取': {
    zh: '爬取',
    en: 'Crawled',
    ar: 'زحف',
    fa: 'خزیده است',
    pt: 'Rastreado'
  },
  '请勾选已爬取的影片': {
    zh: '请勾选已爬取的影片',
    en: 'Please check the crawled videos',
    ar: 'يرجى التحقق من مقاطع الفيديو التي تم الزحف إليها',
    fa: 'لطفاً ویدیوهای خزیده شده را بررسی کنید',
    pt: 'Verifique os vídeos rastreados'
  },
  '国家关联分类': {
    zh: '国家关联分类',
    en: 'Country Association Classification',
    ar: 'تصنيف ارتباط الدول',
    fa: 'طبقه‌بندی ارتباط کشورها',
    pt: 'Classificação de Associação de Países'
  },
  '国家关联分类配置': {
    zh: '国家关联分类配置',
    en: 'Country Association Classification Configuration',
    ar: 'إعداد تصنيف ارتباط الدول',
    fa: 'پیکربندی طبقه‌بندی ارتباط کشورها',
    pt: 'Configuração de Classificação de Associação de Países'
  },
  '国家与分类关联后，在该国家使用时分类将会置顶显示': {
    zh: '国家与分类关联后，在该国家使用时分类将会置顶显示',
    en: 'After associating the country with the category, the category will be displayed at the top when used in that country.',
    ar: 'بعد ربط الدولة بالفئة، ستظهر الفئة في الأعلى عند استخدامها في تلك الدولة.',
    fa: 'پس از ارتباط کشور با دسته‌بندی، هنگام استفاده در آن کشور، دسته‌بندی در بالای صفحه نمایش داده خواهد شد.',
    pt: 'Após a associação do país com a categoria, a categoria será exibida no topo quando usada neste país.'
  },
  '主菜单内容关联': {
    zh: '主菜单内容关联',
    en: 'Menu Associations',
    ar: 'ارتباطات القائمة',
    fa: 'ارتباطات منو',
    pt: 'Associações de Menu'
  },
  '终端应用设置': {
    zh: '终端应用设置',
    en: 'SN Block',
    ar: 'حظر SN',
    fa: 'مسدودسازی SN',
    pt: 'Bloqueio de SN'
  },
  '屏蔽': {
    zh: '屏蔽',
    en: 'Block',
    ar: 'حظر',
    fa: 'مسدود کردن',
    pt: 'Bloquear'
  },
  '屏蔽应用': {
    zh: '屏蔽应用',
    en: 'Block Application',
    ar: 'حظر التطبيق',
    fa: 'مسدود کردن برنامه',
    pt: 'Bloquear Aplicativo'
  },
  '应用列表': {
    zh: '应用列表',
    en: 'Application List',
    ar: 'قائمة التطبيقات',
    fa: 'فهرست برنامه‌ها',
    pt: 'Lista de Aplicativos'
  },
  '请输入关键词': {
    zh: '请输入关键词',
    en: 'Please enter a keyword',
    ar: 'الرجاء إدخال كلمة مفتاحية',
    fa: 'لطفاً کلمه کلیدی را وارد کنید',
    pt: 'Por favor, insira uma palavra-chave'
  },
  '全选': {
    zh: '全选',
    en: 'All',
    ar: 'الكل',
    fa: 'همه',
    pt: 'Tudo'
  },
  '确定移除': {
    zh: '确定移除',
    en: 'Confirm to remove',
    ar: 'تأكيد للإزالة',
    fa: 'تأیید برای حذف',
    pt: 'Confirmar para Remover'
  },
  '请选择一个应用': {
    zh: '请选择一个应用',
    en: 'Please select an application',
    ar: 'يرجى اختيار تطبيق',
    fa: 'لطفاً یک برنامه را انتخاب کنید',
    pt: 'Por favor, selecione um aplicativo'
  },
  '请选择终端': {
    zh: '请选择终端',
    en: 'Please select the terminal',
    ar: 'الرجاء تحديد المحطة',
    fa: 'لطفاً ترمینال را انتخاب کنید',
    pt: 'Por favor, selecione o terminal'
  },
  '是否4K': {
    zh: '是否4K',
    en: '4K',
    ar: '4K',
    fa: '4K',
    pt: '4K'
  },
  '终端': {
    zh: '终端',
    en: 'Terminal',
    ar: 'محطة (Maḥaṭa)',
    fa: 'ترمینال (Terminal)',
    pt: 'Terminal'
  },
  '编辑模板': {
    zh: '编辑模板',
    en: 'Edit Template',
    ar: 'تحرير القالب (Taḥrīr al-Qālib)',
    fa: 'ویرایش قالب (Virāyeš-e Qāleb)',
    pt: 'Editar Modelo'
  },
  '静态主题': {
    zh: '静态主题',
    en: 'Static Theme',
    ar: 'موضوع ثابت (Mawḍūw Thābit)',
    fa: 'تم ثابت (Tam-e Sābet)',
    pt: 'Tema Estático'
  },
  '动态主题': {
    zh: '动态主题',
    en: 'Dynamic Theme',
    ar: 'موضوع ديناميكي (Mawḍūw Dīnāmīkī)',
    fa: 'تم پویا (Tam-e Puya)',
    pt: 'Tema Dinâmico'
  },
  '修改还未保存，确定离开?': {
    zh: '修改还未保存，确定离开?',
    en: 'Changes not saved. Are you sure you want to leave?',
    ar: 'التغييرات لم تحفظ. هل أنت متأكد أنك تريد المغادرة؟',
    fa: 'تغییرات ذخیره نشده‌اند. آیا مطمئن هستید که می‌خواهید خارج شوید؟',
    pt: 'As alterações não foram salvas. Tem certeza de que deseja sair?'
  },
  '影片编码标准': {
    zh: '影片编码标准',
    en: 'Encoding',
    ar: 'ترميز',
    fa: 'رمز استاندارد',
    pt: 'Codificação '
  },
  '字幕语言': {
    zh: '字幕语言',
    en: 'Subtitle Language',
    ar: 'لغة الترجمة',
    fa: 'زبان زیرنویس',
    pt: 'Idioma da Legenda'
  },
  '添加季': {
    zh: '添加季',
    en: 'Add Season',
    ar: 'موسم (مسلسل)',
    fa: 'فصل (سریال) ',
    pt: 'Adicionar Temp'
  },
  '折叠': {
    zh: '折叠',
    en: 'Collapse',
    ar: 'طي',
    fa: 'جمع‌کردن',
    pt: 'Recolher'
  },
  '展开': {
    zh: '展开',
    en: 'Expand',
    ar: 'توسيع',
    fa: 'گسترش',
    pt: 'Expandir'
  },
  '至少保留一季': {
    zh: '至少保留一季',
    en: 'Keep at least one season',
    ar: 'احتفظ بموسم واحد على الأقل',
    fa: 'حداقل یک فصل را نگه دارید	',
    pt: 'Mantenha pelo menos uma temporada	'
  },
  '选择季': {
    zh: '选择季',
    en: 'Select Season',
    ar: 'اختيار الموسم	',
    fa: 'انتخاب فصل	',
    pt: 'Selecionar Temporada'
  },
  '图库选图': {
    zh: '图库选图',
    en: 'Gallery Select',
    ar: 'اختيار من المعرض	',
    fa: 'انتخاب از گالری',
    pt: 'Seleção da Galeria'
  },
  '图库预览': {
    zh: '图库预览',
    en: 'Gallery Preview',
    ar: 'معاينة المعرض	',
    fa: 'پیش‌نمایش گالری	',
    pt: 'Pré-visualização da Galeria'
  },
  '云盘账号管理': {
    zh: '云盘账号管理',
    en: 'Cloud Drive Account Management',
    ar: 'إدارة حسابات التخزين السحابي',
    fa: 'مدیریت حساب‌های فضای ابری',
    pt: 'Gerenciamento de contas de armazenamento em nuvem'
  },
  '云盘链接管理': {
    zh: '云盘链接管理',
    en: 'Cloud Drive Link Management',
    ar: 'إدارة روابط التخزين السحابي',
    fa: 'مدیریت لینک‌های فضای ابری',
    pt: 'Gerenciamento de links de armazenamento em nuvem'
  },
  '网盘平台': {
    zh: '网盘平台',
    en: 'Cloud Storage Platform',
    ar: 'منصة التخزين السحابي',
    fa: 'پلتفرم ذخیره‌سازی ابری',
    pt: 'Plataforma de armazenamento em nuvem'
  },
  '是否删除该账号': {
    zh: '是否删除该账号',
    en: 'Delete this account?',
    ar: 'حذف هذا الحساب؟',
    fa: 'آیا این حساب حذف شود؟',
    pt: 'Excluir esta conta?'
  },
  '云盘分享链接': {
    zh: '云盘分享链接',
    en: 'Cloud Drive Share Link',
    ar: 'رابط مشاركة التخزين السحابي',
    fa: 'لینک اشتراک‌گذاری فضای ابری',
    pt: 'Link de compartilhamento do armazenamento em nuvem'
  },
  '更换': {
    zh: '更换',
    en: 'Change',
    ar: 'تغيير',
    fa: 'تغییر',
    pt: 'Alteração'
  },
  '至少保留一个语言': {
    zh: '至少保留一个语言',
    en: 'Keep at least one language.',
    ar: 'احتفظ بلغة واحدة على الأقل. (Iḥtfaẓ bi-lughah wāḥidah ʿalā al-aqall.)',
    fa: 'حداقل یک زبان را حفظ کنید. (Hadd-eaghal yek zabân râ hefz konid.)',
    pt: 'Mantenha pelo menos um idioma.'
  },
  '请先删除剧集内容再删除语言': {
    zh: '请先删除剧集内容再删除语言',
    en: 'Please delete the episode content first, then remove the language.',
    ar: 'الرجاء حذف محتوى الحلقة أولاً، ثم إزالة اللغة.',
    fa: 'لطفاً ابتدا محتوای قسمت را حذف کنید، سپس زبان را حذف نمایید.',
    pt: 'Por favor, exclua o conteúdo do episódio primeiro, depois remova o idioma.'
  },
  '是否删除该语言?': {
    zh: '是否删除该语言?',
    en: 'Do you want to delete this language?',
    ar: 'هل تريد حذف هذه اللغة؟',
    fa: 'آیا می‌خواهید این زبان را حذف کنید؟',
    pt: 'Deseja excluir este idioma?'
  },
  '转码ID': {
    zh: '转码ID',
    en: 'Output ID',
    ar: 'معرف الإخراج',
    fa: 'شناسه خروجی',
    pt: 'ID de saída'
  },
  '输出路径': {
    zh: '输出路径',
    en: 'Output Path',
    ar: 'مسار الإخراج',
    fa: 'مسیر خروجی',
    pt: 'Caminho de Saída'
  },
  '请选择输出路径': {
    zh: '请选择输出路径',
    en: 'Please select output path',
    ar: 'الرجاء تحديد مسار الإخراج',
    fa: 'لطفا مسیر خروجی را انتخاب کنید',
    pt: 'Por favor, selecione o caminho de saída'
  },
  'S3存储': {
    zh: 'S3存储',
    en: 'S3 Storage',
    ar: 'تخزين S3	',
    fa: 'ذخیره‌سازی S3	',
    pt: 'Armazenamento S3	'
  },
  'GS存储': {
    zh: 'GS存储',
    en: 'GS Storage',
    ar: 'تخزين GS',
    fa: 'ذخیره‌سازی GS',
    pt: 'Armazenamento GS'
  },
  '是否删除该链接': {
    zh: '是否删除该链接',
    en: 'Should this link be deleted?',
    ar: 'هل يجب حذف هذا الرابط؟',
    fa: 'آیا این لینک باید حذف شود؟',
    pt: 'Este link deve ser excluído?'
  },
  '防盗链监管': {
    zh: '防盗链监管',
    en: 'Anti-Leecher Monitoring',
    ar: 'مراقبة مكافحة السرقة',
    fa: 'نظارت ضد دزدی لینک',
    pt: 'Monitoramento Anti-Roubo de Links'
  },
  '账号/SN监管': {
    zh: '账号/SN监管',
    en: 'Account/SN Monitoring',
    ar: 'مراقبة الحساب/الرقم التسلسلي',
    fa: 'نظارت حساب/شماره سریال',
    pt: 'Monitoramento de Conta/SN'
  },
  '账号/SN': {
    zh: '账号/SN',
    en: 'Account/SN',
    ar: 'الحساب/الرقم التسلسلي',
    fa: 'حساب/شماره سریال',
    pt: 'Conta/SN'
  },
  '账号/SN异常列表': {
    zh: '账号/SN异常列表',
    en: 'Account/SN Exception List',
    ar: 'قائمة الاستثناءات للحساب/الرقم التسلسلي',
    fa: 'لیست حساب/شماره سریال غیرعادی',
    pt: 'Lista de Exceções de Conta/SN'
  },
  '账号ID': {
    zh: '账号ID',
    en: 'Account ID',
    ar: 'معرف الحساب',
    fa: 'شناسه حساب',
    pt: 'ID da Conta'
  },
  '日志量': {
    zh: '日志量',
    en: 'Log Volume',
    ar: 'حجم السجلات',
    fa: 'حجم لاگ',
    pt: 'Volume de Logs'
  },
  '请求计数': {
    zh: '请求计数',
    en: 'Request Count',
    ar: 'عدد الطلبات',
    fa: 'تعداد درخواست',
    pt: 'Contagem de Solicitações'
  },
  '请求节目': {
    zh: '请求节目',
    en: 'Requested Program',
    ar: 'البرنامج المطلوب',
    fa: 'برنامه درخواستی',
    pt: 'Programa Solicitado'
  },
  '某一秒内请求多个节目mpd文件，该值+1': {
    zh: '某一秒内请求多个节目mpd文件，该值+1',
    en: 'Requesting multiple program MPD files within one second increments this value by 1',
    ar: 'طلب ملفات MPD لبرامج متعددة خلال ثانية واحدة يزيد هذه القيمة بمقدار 1',
    fa: 'درخواست چند فایل MPD برنامه در یک ثانیه این مقدار را +1 می‌کند',
    pt: 'Solicitar vários arquivos MPD de programa em um segundo incrementa este valor em 1'
  },
  '选取某一时刻请求多个节目的节目列表': {
    zh: '选取某一时刻请求多个节目的节目列表',
    en: 'Select a program list requesting multiple programs at a certain time',
    ar: 'حدد قائمة برامج تطلب برامج متعددة في وقت معين',
    fa: 'لیست برنامه‌هایی که در یک زمان خاص چندین برنامه درخواست کرده‌اند را انتخاب کنید',
    pt: 'Selecione uma lista de programas solicitando vários programas em um determinado momento'
  },
  '选取时刻': {
    zh: '选取时刻',
    en: 'Selected Time',
    ar: 'الوقت المحدد',
    fa: 'زمان انتخاب شده',
    pt: 'Momento Selecionado'
  },
  '请求节目详情': {
    zh: '请求节目详情',
    en: 'Requested Program Details',
    ar: 'تفاصيل البرنامج المطلوب',
    fa: 'جزئیات برنامه درخواستی',
    pt: 'Detalhes do Programa Solicitado'
  },
  'IP详情': {
    zh: 'IP详情',
    en: 'IP Details',
    ar: 'تفاصيل IP',
    fa: 'جزئیات آی پی',
    pt: 'Detalhes do IP'
  },
  'IP异常列表': {
    zh: 'IP异常列表',
    en: 'IP Exception List',
    ar: 'قائمة استثناءات IP',
    fa: 'لیست آی پی های غیرعادی',
    pt: 'Lista de Exceções de IP'
  },
  'SN详情': {
    zh: 'SN详情',
    en: 'SN Details',
    ar: 'تفاصيل الرقم التسلسلي',
    fa: 'جزئیات شماره سریال',
    pt: 'Detalhes do SN'
  },
  '确定将此IP移除黑名单': {
    zh: '确定将此IP移除黑名单',
    en: 'Confirm to remove this IP from blacklist',
    ar: 'تأكيد إزالة هذا الـ IP من القائمة السوداء',
    fa: 'آیا از حذف این آی پی از لیست سیاه مطمئنید؟',
    pt: 'Confirmar remoção deste IP da lista negra'
  },
  '确定将此IP加入黑名单': {
    zh: '确定将此IP加入黑名单',
    en: 'Confirm to add this IP to blacklist',
    ar: 'تأكيد إضافة هذا الـ IP إلى القائمة السوداء',
    fa: 'آیا از افزودن این آی پی به لیست سیاه مطمئنید؟',
    pt: 'Confirmar adição deste IP à lista negra'
  },
  '已拉黑': {
    zh: '已拉黑',
    en: 'Blacklisted',
    ar: 'مدرج في القائمة السوداء',
    fa: 'لیست سیاه شده',
    pt: 'Na lista negra'
  },
  '未拉黑': {
    zh: '未拉黑',
    en: 'Not Blacklisted',
    ar: 'غير مدرج في القائمة السوداء',
    fa: 'لیست سیاه نشده',
    pt: 'Fora da lista negra'
  },
  '移除黑名单': {
    zh: '移除黑名单',
    en: 'Remove from Blacklist',
    ar: 'إزالة من القائمة السوداء',
    fa: 'حذف از لیست سیاه',
    pt: 'Remover da Lista Negra'
  },
  '加入黑名单': {
    zh: '加入黑名单',
    en: 'Add to Blacklist',
    ar: 'إضافة إلى القائمة السوداء',
    fa: 'افزودن به لیست سیاه',
    pt: 'Adicionar à Lista Negra'
  },
  '账号/SN黑名单': {
    zh: '账号/SN黑名单',
    en: 'Account/SN Blacklist',
    ar: 'القائمة السوداء للحساب/الرقم التسلسلي',
    fa: 'لیست سیاه حساب/شماره سریال',
    pt: 'Lista Negra de Conta/SN'
  },
  'IP黑名单': {
    zh: 'IP黑名单',
    en: 'IP Blacklist',
    ar: 'القائمة السوداء لـ IP',
    fa: 'لیست سیاه آی پی',
    pt: 'Lista Negra de IP'
  },
  'IP监管': {
    zh: 'IP监管',
    en: 'IP Monitoring',
    ar: 'مراقبة الـIP',
    fa: 'نظارت آی‌پی',
    pt: 'Monitoramento de IP'
  },
  '频道监管': {
    zh: '频道监管',
    en: 'Channel Monitoring',
    ar: 'مراقبة القنوات',
    fa: 'نظارت کانال',
    pt: 'Monitoramento de Canais'
  },
  '播放节目': {
    zh: '播放节目',
    en: 'Playing Program',
    ar: 'برنامج التشغيل',
    fa: 'پخش برنامه',
    pt: 'Programa em Reprodução'
  },
  '中台是否在线': {
    zh: '中台是否在线',
    en: 'Online Status',
    ar: 'حالة الاتصال بالإنترنت',
    fa: 'وضعیت آنلاین',
    pt: 'Status Online'
  },
  '列表心跳': {
    zh: '列表心跳',
    en: 'List Heartbeat',
    ar: 'نبض القائمة',
    fa: 'ضربان لیست',
    pt: 'Pulso da Lista'
  },
  '列表接口请求': {
    zh: '列表接口请求',
    en: 'List Interface Request',
    ar: 'طلب واجهة القائمة',
    fa: 'درخواست رابط لیست',
    pt: 'Solicitação de Interface de Lista'
  },
  '盗链可能性得分': {
    zh: '盗链可能性得分',
    en: 'Hotlinking Probability Score',
    ar: 'درجة احتمالية سرقة الروابط',
    fa: 'امتیاز احتمال دزدی لینک',
    pt: 'Pontuação de Probabilidade de Roubo de Links'
  },
  '防盗链分析': {
    zh: '防盗链分析',
    en: 'Anti-Hotlinking Analysis',
    ar: 'تحليل مكافحة سرقة الروابط',
    fa: 'تجزیه و تحلیل ضد دزدی لینک',
    pt: 'Análise Anti-Roubo de Links'
  },
  '当账号/SN 同时拉流2个节目需要手动判断加入黑名单;当账号/SN 同时拉流大于2个节目自动加入黑名单': {
    zh: '当账号/SN 同时拉流2个节目需要手动判断加入黑名单;当账号/SN 同时拉流大于2个节目自动加入黑名单',
    en: 'When an account/SN pulls 2 streams simultaneously, manual review is required for blacklisting; when pulling more than 2 streams simultaneously, automatic blacklisting occurs',
    ar: 'عند سحب حساب/SN لبرنامجين في نفس الوقت، يتطلب الأمر مراجعة يدوية للإدراج في القائمة السوداء؛ عند سحب أكثر من برنامجين يتم الإدراج تلقائياً في القائمة السوداء',
    fa: 'هنگامی که یک حساب/SN همزمان 2 برنامه را دریافت می‌کند، نیاز به بررسی دستی برای لیست سیاه شدن دارد؛ در صورت دریافت بیش از 2 برنامه، به صورت خودکار لیست سیاه می‌شود',
    pt: 'Quando uma conta/SN puxa 2 transmissões simultaneamente, é necessária revisão manual para inclusão na lista negra; quando puxa mais de 2 transmissões, a inclusão na lista negra é automática'
  },
  '确定将此账号/SN加入黑名单': {
    zh: '确定将此账号/SN加入黑名单',
    en: 'Confirm to add this account/SN to blacklist',
    ar: 'تأكيد إضافة هذا الحساب/الرقم التسلسلي إلى القائمة السوداء',
    fa: 'تأیید افزودن این حساب/شماره سریال به لیست سیاه',
    pt: 'Confirmar adicionar esta conta/SN à lista negra'
  },
  '确定将此账号/SN移除黑名单': {
    zh: '确定将此账号/SN移除黑名单',
    en: 'Confirm to remove this account/SN from blacklist',
    ar: 'تأكيد إزالة هذا الحساب/الرقم التسلسلي من القائمة السوداء',
    fa: 'تأیید حذف این حساب/شماره سریال از لیست سیاه',
    pt: 'Confirmar remover esta conta/SN da lista negra'
  },
  '终端类型': {
    zh: '终端类型',
    en: 'Terminal Type',
    ar: 'نوع الجهاز الطرفي',
    fa: 'نوع ترمینال',
    pt: 'Tipo de Terminal'
  },
  '是否确认将影片取消关联云盘？': {
    zh: '是否确认将影片取消关联云盘？',
    en: 'Are you sure you want to unlink this video from cloud storage?',
    ar: 'هل أنت متأكد أنك تريد إلغاء ربط هذا الفيديو بالتخزين السحابي؟',
    fa: 'آیا از قطع ارتباط این ویدئو با فضای ابری اطمینان دارید؟',
    pt: 'Tem certeza que deseja desvincular este vídeo do armazenamento em nuvem?'
  },
  '取消关联': {
    zh: '取消关联',
    en: 'Unlink',
    ar: 'إلغاء الربط',
    fa: 'قطع ارتباط',
    pt: 'Desvincular'
  },
  '云盘': {
    zh: '云盘',
    en: 'Cloud Storage',
    ar: 'التخزين السحابي',
    fa: 'فضای ابری',
    pt: 'Armazenamento em Nuvem'
  },
  '已关联': {
    zh: '已关联',
    en: 'Linked',
    ar: 'مرتبط',
    fa: 'مرتبط شده',
    pt: 'Vinculado'
  },
  '未关联': {
    zh: '未关联',
    en: 'Not Linked',
    ar: 'غير مرتبط',
    fa: 'مرتبط نشده',
    pt: 'Não Vinculado'
  },
  '取消关联云盘': {
    zh: '取消关联云盘',
    en: 'Unlink Cloud Disk',
    ar: 'إلغاء ربط القرص السحابي',
    fa: 'قطع ارتباط دیسک ابری',
    pt: 'Desvincular Disco na Nuvem'
  },
  '批量取消关联云盘': {
    zh: '批量取消关联云盘',
    en: 'Bulk Unlink Cloud Disk',
    ar: 'إلغاء ربط جماعي للقرص السحابي',
    fa: 'قطع ارتباط دسته‌جمعی دیسک ابری',
    pt: 'Desvincular em Massa Disco na Nuvem'
  },
  '点播播放配置': {
    zh: '点播播放配置',
    en: 'VOD Play Setting',
    ar: 'تنظیمات تشغيل الفيديو عند الطلب',
    fa: 'تنظیمات پخش ویدیو درخواستی',
    pt: 'Configurações de Reprodução VOD'
  },
  '请输入备注': {
    zh: '请输入备注',
    en: 'Please enter remarks',
    ar: 'الرجاء إدخال الملاحظات',
    fa: 'لطفاً یادداشت وارد کنید',
    pt: 'Por favor insira observações'
  },
  '支持儿童模式': {
    zh: '支持儿童模式',
    en: 'Supports Kids Mode',
    ar: 'يدعم وضع الأطفال',
    fa: 'پشتیبانی از حالت کودک',
    pt: 'Suporta Modo Infantil'
  },
  '儿童模式': {
    zh: '儿童模式',
    en: 'Kids Mode',
    ar: 'وضع الأطفال',
    fa: 'حالت کودک',
    pt: 'Modo Infantil'
  },
  '常规模式': {
    zh: '常规模式',
    en: 'Regular Mode',
    ar: 'الوضع العادي',
    fa: 'حالت معمولی',
    pt: 'Modo Regular'
  },
  '服务器主备设置': {
    zh: '服务器主备设置',
    en: 'Server Primary/Backup Settings',
    ar: 'إعدادات الخادم الرئيسي/الاحتياطي',
    fa: 'تنظیمات سرور اصلی/پشتیبان',
    pt: 'Configuração de Servidor Principal/Backup'
  },
  '备地址': {
    zh: '备地址',
    en: 'Backup Address',
    ar: 'عنوان النسخ الاحتياطي',
    fa: 'آدرس پشتیبان',
    pt: 'Endereço de Backup'
  },
  '新增主服务器': {
    zh: '新增主服务器',
    en: 'Add Primary Server',
    ar: 'إضافة خادم رئيسي',
    fa: 'افزودن سرور اصلی',
    pt: 'Adicionar Servidor Principal'
  },
  '编辑主服务器': {
    zh: '编辑主服务器',
    en: 'Edit Primary Server',
    ar: 'تحرير الخادم الرئيسي',
    fa: 'ویرایش سرور اصلی',
    pt: 'Editar Servidor Principal'
  },
  '编辑备用服务器': {
    zh: '编辑备用服务器',
    en: 'Edit Backup Server',
    ar: 'تحرير الخادم الاحتياطي',
    fa: 'ویرایش سرور پشتیبان',
    pt: 'Editar Servidor de Backup'
  },
  '新增备用服务器': {
    zh: '新增备用服务器',
    en: 'Add Backup Server',
    ar: 'إضافة خادم احتياطي',
    fa: 'افزودن سرور پشتیبان',
    pt: 'Adicionar Servidor de Backup'
  },
  '私钥键': {
    zh: '私钥键',
    en: 'Private Key',
    ar: 'مفتاح خاص',
    fa: 'کلید خصوصی',
    pt: 'Chave Privada'
  },
  '私钥值': {
    zh: '私钥值',
    en: 'Private Value',
    ar: 'قيمة المفتاح الخاص',
    fa: 'مقدار کلید خصوصی',
    pt: 'Valor da Chave Privada'
  },
  '播放配置': {
    zh: '播放配置',
    en: 'Play Setting',
    ar: 'إعدادات التشغيل',
    fa: 'تنظیمات پخش',
    pt: 'Configurações de Reprodução'
  },
  '请选择主题方式': {
    zh: '请选择主题方式',
    en: 'Please select theme type',
    ar: 'الرجاء تحديد نوع الموضوع',
    fa: 'لطفاً انتخاب نوع موضوع',
    pt: 'Por favor selecione o tipo de tema'
  },
  '国家设置': {
    zh: '国家设置',
    en: 'Country Setting',
    ar: 'إعدادات الدولة',
    fa: 'تنظیمات کشور',
    pt: 'Configurações de País'
  },
  '地区': {
    zh: '地区',
    en: 'Region',
    ar: 'المنطقة',
    fa: 'منطقه',
    pt: 'Região'
  },
  '城市': {
    zh: '城市',
    en: 'City',
    ar: 'المدينة',
    fa: 'شهر',
    pt: 'Cidade'
  },
  '以太网mac地址': {
    zh: '以太网mac地址',
    en: 'Ethernet Mac Address',
    ar: 'عنوان MAC لشبكة الإيثرنت',
    fa: 'آدرس MAC اترنت',
    pt: 'Endereço MAC Ethernet'
  },
  'Wifi mac地址': {
    zh: 'Wifi mac地址',
    en: 'Wifi Mac Address',
    ar: 'عنوان MAC للواي فاي',
    fa: 'آدرس MAC وای‌فای',
    pt: 'Endereço MAC do Wi‑Fi'
  },
  '蓝牙mac地址': {
    zh: '蓝牙mac地址',
    en: 'Bluetooth Mac Address',
    ar: 'عنوان MAC للبلوتوث',
    fa: 'آدرس MAC بلوتوث',
    pt: 'Endereço MAC do Bluetooth'
  },
  'android系统版本': {
    zh: 'android系统版本',
    en: 'Android Version',
    ar: 'إصدار أندرويد',
    fa: 'نسخه اندروید',
    pt: 'Versão do Android'
  },
  '制造商': {
    zh: '制造商',
    en: 'Manufacturer',
    ar: 'المُصنِّع',
    fa: 'سازنده',
    pt: 'Fabricante'
  },
  '设备代号': {
    zh: '设备代号',
    en: 'Device Codename',
    ar: 'الاسم الرمزي للجهاز',
    fa: 'نام رمز دستگاه',
    pt: 'Codinome do dispositivo'
  },
  '硬件名称': {
    zh: '硬件名称',
    en: 'Hardware Name',
    ar: 'اسم العتاد',
    fa: 'نام سخت‌افزار',
    pt: 'Nome do hardware'
  },
  '主板型号': {
    zh: '主板型号',
    en: 'Motherboard Model',
    ar: 'طراز اللوحة الأم',
    fa: 'مدل مادربرد',
    pt: 'Modelo da placa-mãe'
  },
  '内存大小(MB)': {
    zh: '内存大小(MB)',
    en: 'Memory Size (MB)',
    ar: 'حجم الذاكرة (MB)',
    fa: 'حجم حافظه (MB)',
    pt: 'Tamanho da memória (MB)'
  },
  '硬盘大小(MB)': {
    zh: '硬盘大小(MB)',
    en: 'Disk Size (MB)',
    ar: 'حجم التخزين (MB)',
    fa: 'حجم ذخیره‌سازی (MB)',
    pt: 'Tamanho do armazenamento (MB)'
  },
  'IMEI号': {
    zh: 'IMEI号',
    en: 'IMEI',
    ar: 'رقم IMEI',
    fa: 'شماره IMEI',
    pt: 'IMEI'
  },
  '序列化号': {
    zh: '序列化号',
    en: 'Serial Number',
    ar: 'الرقم التسلسلي',
    fa: 'شماره سریال',
    pt: 'Número de série'
  },
  '设备信息': {
    zh: '设备信息',
    en: 'Device Information',
    ar: 'معلومات الجهاز',
    fa: 'اطلاعات دستگاه',
    pt: 'Informações do Dispositivo'
  },
  '禁用': {
    zh: '禁用',
    en: 'Disabled',
    ar: 'مقيد',
    fa: 'محدود شده است',
    pt: 'Desabilitado'
  },
  '内嵌字幕': {
    zh: '内嵌字幕',
    en: 'Embedded Subtitles',
    ar: 'الترجمات المدمجة',
    fa: 'زیرنویس های تعبیه شده',
    pt: 'Legendas Incorporadas'
  },
  '年龄水印存储地址': {
    zh: '年龄水印存储地址',
    en: 'Age Watermark Storage Address',
    ar: 'عنوان تخزين علامة العمر المائية',
    fa: 'آدرس ذخیره سازی واترمارک سن',
    pt: 'Endereço de Armazenamento da Marca d\'Água de Idade'
  },
  '年龄水印位置': {
    zh: '年龄水印位置',
    en: 'Age Watermark Position',
    ar: 'موضع علامة العمر المائية',
    fa: 'موقعیت واترمارک سن',
    pt: 'Posição da Marca d\'Água de Idade'
  },
  '年龄水印宽高': {
    zh: '年龄水印宽高',
    en: 'Age Watermark Width & Height',
    ar: 'عرض وارتفاع علامة العمر المائية',
    fa: 'عرض و ارتفاع واترمارک سن',
    pt: 'Largura e Altura da Marca d\'Água de Idade'
  },
  '水印存储地址': {
    zh: '水印存储地址',
    en: 'Watermark Storage Address',
    ar: 'عنوان تخزين العلامة المائية',
    fa: 'آدرس ذخیره سازی واترمارک',
    pt: 'Endereço de Armazenamento da Marca d\'Água'
  },
  '水印位置': {
    zh: '水印位置',
    en: 'Watermark Position',
    ar: 'موضع العلامة المائية',
    fa: 'موقعیت واترمارک',
    pt: 'Posição da Marca d\'Água'
  },
  '水印宽高': {
    zh: '水印宽高',
    en: 'Watermark Width & Height',
    ar: 'عرض وارتفاع العلامة المائية',
    fa: 'عرض و ارتفاع واترمارک',
    pt: 'Largura e Altura da Marca d\'Água'
  },
  '请选择运营区域': {
    zh: '请选择运营区域',
    en: 'Please select the operating area',
    ar: 'الرجاء اختيار منطقة التشغيل',
    fa: 'لطفا منطقه عملیاتی را انتخاب کنید',
    pt: 'Selecione por favor a área operacional'
  },
  '重点节目分组': {
    zh: '重点节目分组',
    en: 'Key Program Groups',
    ar: 'مجموعات البرامج الرئيسية',
    fa: 'گروه های برنامه کلیدی',
    pt: 'Grupos de Programas Principais'
  },
  '全部分组': {
    zh: '全部分组',
    en: 'All Groups',
    ar: 'جميع المجموعات',
    fa: 'همه گروه ها',
    pt: 'Todos os Grupos'
  },
  '添加分组': {
    zh: '添加分组',
    en: 'Add Group',
    ar: 'إضافة مجموعة',
    fa: 'افزودن گروه',
    pt: 'Adicionar Grupo'
  },
  '更改名称': {
    zh: '更改名称',
    en: 'Rename',
    ar: 'تغيير الاسم',
    fa: 'تغییر نام',
    pt: 'Renomear'
  },
  '错误节点数量': {
    zh: '错误节点数量',
    en: 'Error Node Count',
    ar: 'عدد العقد الخاطئة',
    fa: 'تعداد گره های خطا',
    pt: 'Contagem de Nós de Erro'
  },
  'MPD错误数量': {
    zh: 'MPD错误数量',
    en: 'MPD Error Count',
    ar: 'عدد أخطاء MPD',
    fa: 'تعداد خطاهای MPD',
    pt: 'Contagem de Erros MPD'
  },
  '切片错误数量': {
    zh: '切片错误数量',
    en: 'Segment Error Count',
    ar: 'عدد أخطاء القطاعات',
    fa: 'تعداد خطاهای بخش',
    pt: 'Contagem de Erros de Segmento'
  },
  '查看详情': {
    zh: '查看详情',
    en: 'View Details',
    ar: 'عرض التفاصيل',
    fa: 'مشاهده جزئیات',
    pt: 'Ver Detalhes'
  },
  '用户数据监管': {
    zh: '用户数据监管',
    en: 'User Data Monitoring',
    ar: 'مراقبة بيانات المستخدم',
    fa: 'نظارت داده های کاربر',
    pt: 'Monitoramento de Dados do Usuário'
  },
  '业务数据监管': {
    zh: '业务数据监管',
    en: 'Business Data Monitoring',
    ar: 'مراقبة بيانات الأعمال',
    fa: 'نظارت داده های کسب و کار',
    pt: 'Monitoramento de Dados de Negócios'
  },
  '播放质量监管': {
    zh: '播放质量监管',
    en: 'Playback Quality Monitoring',
    ar: 'مراقبة جودة التشغيل',
    fa: 'نظارت کیفیت پخش',
    pt: 'Monitoramento de Qualidade de Reprodução'
  },
  '点播节目': {
    zh: '点播节目',
    en: 'Vod Channel',
    ar: 'قناة الفيديو عند الطلب',
    fa: 'کانال ویدیو درخواستی',
    pt: 'Canal VOD'
  },
  '自动刷新': {
    zh: '自动刷新',
    en: 'Auto Refresh',
    ar: 'تحديث تلقائي',
    fa: 'تازه کردن خودکار',
    pt: 'Atualização Automática'
  },
  '过去1分钟': {
    zh: '过去1分钟',
    en: 'Last 1 Minute',
    ar: 'آخر دقيقة',
    fa: 'یک دقیقه گذشته',
    pt: 'Último 1 Minuto'
  },
  '过去2分钟': {
    zh: '过去2分钟',
    en: 'Last 2 Minutes',
    ar: 'آخر دقيقتين',
    fa: 'دو دقیقه گذشته',
    pt: 'Últimos 2 Minutos'
  },
  '过去3分钟': {
    zh: '过去3分钟',
    en: 'Last 3 Minutes',
    ar: 'آخر 3 دقائق',
    fa: 'سه دقیقه گذشته',
    pt: 'Últimos 3 Minutos'
  },
  '过去4分钟': {
    zh: '过去4分钟',
    en: 'Last 4 Minutes',
    ar: 'آخر 4 دقائق',
    fa: 'چهار دقیقه گذشته',
    pt: 'Últimos 4 Minutos'
  },
  '过去5分钟': {
    zh: '过去5分钟',
    en: 'Last 5 Minutes',
    ar: 'آخر 5 دقائق',
    fa: 'پنج دقیقه گذشته',
    pt: 'Últimos 5 Minutos'
  },
  '过去10分钟': {
    zh: '过去10分钟',
    en: 'Last 10 Minutes',
    ar: 'آخر 10 دقائق',
    fa: 'ده دقیقه گذشته',
    pt: 'Últimos 10 Minutos'
  },
  '过去30分钟': {
    zh: '过去30分钟',
    en: 'Last 30 Minutes',
    ar: 'آخر 30 دقيقة',
    fa: 'سی دقیقه گذشته',
    pt: 'Últimos 30 Minutos'
  },
  '过去1小时': {
    zh: '过去1小时',
    en: 'Last 1 Hour',
    ar: 'آخر ساعة',
    fa: 'یک ساعت گذشته',
    pt: 'Última 1 Hora'
  },
  '过去1天': {
    zh: '过去1天',
    en: 'Last 1 Day',
    ar: 'آخر يوم',
    fa: 'یک روز گذشته',
    pt: 'Último 1 Dia'
  },
  '过去1周': {
    zh: '过去1周',
    en: 'Last 1 Week',
    ar: 'آخر أسبوع',
    fa: 'یک هفته گذشته',
    pt: 'Última 1 Semana'
  },

  '边缘节点': {
    zh: '边缘节点',
    en: 'Edge Node',
    ar: 'العقدة الطرفية',
    fa: 'گره لبه',
    pt: 'Nó de Borda'
  },
  '错误类型': {
    zh: '错误类型',
    en: 'Error Type',
    ar: 'نوع الخطأ',
    fa: 'نوع خطا',
    pt: 'Tipo de Erro'
  },
  '状态码': {
    zh: '状态码',
    en: 'Status Code',
    ar: 'رمز الحالة',
    fa: 'کد وضعیت',
    pt: 'Código de Status'
  },
  '远端地址': {
    zh: '远端地址',
    en: 'Remote Address',
    ar: 'العنوان البعيد',
    fa: 'آدرس دور',
    pt: 'Endereço Remoto'
  },
  '回源地址': {
    zh: '回源地址',
    en: 'Origin Address',
    ar: 'عنوان المصدر',
    fa: 'آدرس مبدا',
    pt: 'Endereço de Origem'
  },
  'MPD错误': {
    zh: 'MPD错误',
    en: 'MPD Error',
    ar: 'خطأ MPD',
    fa: 'خطای MPD',
    pt: 'Erro MPD'
  },
  '切片错误': {
    zh: '切片错误',
    en: 'Segment Error',
    ar: 'خطأ القطاع',
    fa: 'خطای بخش',
    pt: 'Erro de Segmento'
  },
  '是否删除该域名': {
    zh: '是否删除该域名',
    en: 'Delete this domain?',
    ar: 'حذف هذا النطاق؟',
    fa: 'آیا این دامنه حذف شود؟',
    pt: 'Excluir este domínio?'
  },
  '原始地址': {
    zh: '原始地址',
    en: 'Original Address',
    ar: 'العنوان الأصلي',
    fa: 'آدرس اصلی',
    pt: 'Endereço Original'
  },
  '转换地址': {
    zh: '转换地址',
    en: 'Mapped Address',
    ar: 'العنوان المربوط',
    fa: 'آدرس نگاشت شده',
    pt: 'Endereço Mapeado'
  },
  'Netfly域名转换': {
    zh: 'Netfly域名转换',
    en: 'Netfly Domain Mapping',
    ar: 'ربط نطاق Netfly',
    fa: 'نگاشت دامنه Netfly',
    pt: 'Mapeamento de Domínio Netfly'
  },
  'NetFly监管统计': {
    zh: 'NetFly监管统计',
    en: 'NetFly Monitoring',
    ar: 'مراقبة NetFly',
    fa: 'نظارت NetFly',
    pt: 'Monitoramento NetFly'
  },
  '直播节目': {
    zh: '直播节目',
    en: 'Live Channel',
    ar: 'قناة مباشرة',
    fa: 'کانال زنده',
    pt: 'Canal ao Vivo'
  },
  '直播节目监管': {
    zh: '直播节目监管',
    en: 'Live Channel Monitor',
    ar: 'مراقبة برامج البث المباشر',
    fa: 'نظارت بر برنامه‌های پخش زنده',
    pt: 'Monitoramento de Canal ao Vivo'
  },
  '确定并添加节目': {
    zh: '确定并添加节目',
    en: 'Confirm and Add Program',
    ar: 'تأكيد وإضافة البرنامج',
    fa: 'تأیید و افزودن برنامه',
    pt: 'Confirmar e Adicionar Programa'
  },
  'Mac地址导入': {
    zh: 'Mac地址导入',
    en: 'Import MAC Account',
    ar: 'استيراد حسابات MAC',
    fa: 'وارد کردن حسابات MAC',
    pt: 'Importar contas MAC'
  },
  '导入Mac': {
    zh: '导入Mac',
    en: 'Import MAC',
    ar: 'استيراد MAC',
    fa: 'وارد کردن MAC',
    pt: 'Importar MAC'
  },
  'Validity Period (月)': {
    zh: 'Validity Period (月)',
    en: 'Validity Period (Months)',
    ar: 'فترة الصلاحية (أشهر)',
    fa: 'دوره اعتبار (ماه)',
    pt: 'Período de validade (meses)'
  },
  'MAC文件': {
    zh: 'MAC文件',
    en: 'MAC File',
    ar: 'ملف MAC',
    fa: 'فایل MAC',
    pt: 'Arquivo MAC'
  },
  '系统运维与监控': {
    zh: '系统运维与监控',
    en: 'System Operations',
    ar: 'تشغيل النظام',
    fa: 'عملیات سیستم',
    pt: 'Operações do Sistema'
  },
  '音频语言': {
    zh: '音频语言',
    en: 'Audio Language',
    ar: 'لغة الصوت',
    fa: 'زبان صدا',
    pt: 'Idioma do áudio'
  },
  '音频采样率': {
    zh: '音频采样率',
    en: 'Audio Sample Rate',
    ar: 'معدل أخذ العينات للصوت',
    fa: 'نرخ نمونه‌برداری صدا',
    pt: 'Taxa de amostragem de áudio'
  },
  '是否付费': {
    zh: '是否付费',
    en: 'Paid or Not',
    ar: 'مدفوع أم لا',
    fa: 'پرداخت شده یا خیر',
    pt: 'Pago ou não'
  },
  '发布时间': {
    zh: '发布时间',
    en: 'Release Time',
    ar: 'وقت النشر',
    fa: 'زمان انتشار',
    pt: 'Tempo de lançamento'
  },
  '外部字幕路径': {
    zh: '外部字幕路径',
    en: 'External Subtitle Path',
    ar: 'مسار الترجمة الخارجية',
    fa: 'مسیر ترجمه خارجی',
    pt: 'Caminho da legenda externa'
  },
  '文件导入': {
    zh: '文件导入',
    en: 'File Import',
    ar: 'استيراد الملف',
    fa: 'وارد کردن فایل',
    pt: 'Importar Arquivo'
  },
  '请输入文件路径': {
    zh: '请输入文件路径',
    en: 'Please enter the file path',
    ar: 'يرجى إدخال مسار الملف',
    fa: 'لطفاً مسیر فایل را وارد کنید',
    pt: 'Insira o caminho do arquivo'
  },
  '直播平台维度统计': {
    zh: '平台维度统计',
    en: 'Platform Dimensions',
    ar: 'أبعاد المنصة',
    fa: 'آمار ابعاد پلتفرم',
    pt: 'Dimensão da Plataforma'
  },
  '点播平台维度统计': {
    zh: '平台维度统计',
    en: 'Platform Dimensions',
    ar: 'أبعاد المنصة',
    fa: 'آمار ابعاد پلتفرم',
    pt: 'Dimensão da Plataforma'
  },
  '直播内容维度统计': {
    zh: '内容维度统计',
    en: 'Content Dimensions',
    ar: 'أبعاد المحتوى',
    fa: 'آمار ابعاد محتوا',
    pt: 'Dimensão de Conteúdo'
  },
  '点播内容维度统计': {
    zh: '内容维度统计',
    en: 'Content Dimensions',
    ar: 'أبعاد المحتوى',
    fa: 'آمار ابعاد محتوا',
    pt: 'Dimensão de Conteúdo'
  },
  '直播用户维度统计': {
    zh: '用户维度统计',
    en: 'User-level Statistics',
    ar: 'أبعاد المستخدم',
    fa: 'آمار ابعاد کاربر',
    pt: 'Dimensão do Usuário'
  },
  '直播播放质量统计': {
    zh: '直播播放质量统计',
    en: 'Live Stream Metrics',
    ar: 'إحصائيات قناة زنده',
    fa: 'آمار قناة زنده',
    pt: 'Estatísticas de Canal ao Vivo'
  },
  '点播播放质量统计': {
    zh: '点播播放质量统计',
    en: 'VOD Playback Metrics',
    ar: 'إحصائيات فيديو عند الطلب',
    fa: 'آمار فيديو عند الطلب',
    pt: 'Estatísticas de Reprodução de VOD'
  },
  '外部字幕后缀': {
    zh: '外部字幕后缀',
    en: 'External Subtitle Suffix',
    ar: 'لاحقة الترجمة الخارجية',
    fa: 'پسوند ترجمه خارجی',
    pt: 'Sufixo de Legenda Externa'
  },
  '直播节目维度统计': {
    zh: '节目维度统计',
    en: 'Content Dimensions',
    ar: 'أبعاد البرنامج',
    fa: 'آمار ابعاد البرنامج',
    pt: 'Dimensão do Programa'
  },
  '跳出率': {
    zh: '跳出率',
    en: 'JumpOut Rate',
    ar: '',
    fa: '',
    pt: ''
  },
  '切换成功率': {
    zh: '切换成功率',
    en: 'Switching Success Rate',
    ar: '',
    fa: '',
    pt: ''
  },
  '秒开率': {
    zh: '秒开率',
    en: 'Instant Opean Rate',
    ar: '',
    fa: '',
    pt: ''
  },
  '点播节目维度统计': {
    zh: '节目维度统计',
    en: 'Content Dimensions',
    ar: 'أبعاد البرنامج',
    fa: 'آمار ابعاد البرنامج',
    pt: 'Dimensão do Programa'
  },
  '时间维度_简写': {
    zh: '时间维度',
    en: 'Time',
    ar: 'أبعاد الوقت',
    fa: 'أبعاد زمان',
    pt: 'Dimensão do tempo'
  },
  '节目维度_简写': {
    zh: '节目维度',
    en: 'Programs',
    ar: 'أبعاد البرنامج',
    fa: 'آمار ابعاد البرنامج',
    pt: 'Estatísticas de Dimensão do Programa'
  },
  '单频道维度_简写': {
    zh: '单频道维度',
    en: 'Single Channel',
    ar: 'أبعاد القناة',
    fa: 'آمار ابعاد قناة',
    pt: 'Estatísticas de Dimensão da Canal'
  },
  '用户卡顿监控': {
    zh: '用户卡顿监控',
    en: 'User Lagging Monitor',
    ar: 'مراقبة لگ و توقف المستخدم',
    fa: 'مراقبه لگ و توقف کاربر',
    pt: 'Monitoramento de travamentos e interrupções do usuário'
  },
  '相对卡顿用户': {
    zh: '相对卡顿用户',
    en: 'Relative Lagging Users',
    ar: 'المستخدمين الذين لگ و توقف بنسبة مطلقة',
    fa: 'کاربرانی که لگ و توقف بنسبت مطلق دارند',
    pt: 'Usuários que travaram com uma proporção absoluta'
  },
  '时间': {
    zh: '时间',
    en: 'Time',
    ar: 'الوقت',
    fa: 'زمان',
    pt: 'Tempo'
  },
  '观看总数': {
    zh: '观看总数',
    en: 'Total Viewing Count',
    ar: 'عدد المشاهدات الكلي',
    fa: 'تعداد کل تماشاها',
    pt: 'Total de visualizações'
  },
  '实际卡顿用户': {
    zh: '实际卡顿用户',
    en: 'Actual Lagging Users',
    ar: 'المستخدمين الذين لگ و توقف بالفعل',
    fa: 'کاربرانی که لگ و توقف به طور حقیقی داشته‌اند',
    pt: 'Usuários que realmente travaram'
  },
  '卡顿率': {
    zh: '卡顿率',
    en: 'Lagging Rate',
    ar: 'معدل التوقف',
    fa: 'نرخ لگ و توقف',
    pt: 'Taxa de travamentos e interrupções'
  },
  '过去7天': {
    zh: '过去7天',
    en: 'Past 7 Days',
    ar: 'آخر 7 أيام',
    fa: '7 روز گذشته',
    pt: 'Últimos 7 dias'
  },
  '过去30天': {
    zh: '过去30天',
    en: 'Past 30 Days',
    ar: 'آخر 30 أيام',
    fa: '30 روز گذشته',
    pt: 'Últimos 30 dias'
  },
  '过去90天': {
    zh: '过去90天',
    en: 'Past 90 Days',
    ar: 'آخر 90 أيام',
    fa: '90 روز گذشته',
    pt: 'Últimos 90 dias'
  },
  '数据详情': {
    zh: '数据详情',
    en: 'Detail',
    ar: 'التفاصيل',
    fa: 'جزئیات',
    pt: 'pormenores'
  },
  '内容维度统计信息': {
    zh: '内容维度统计信息',
    en: 'Content Dimension Statistics',
    ar: 'إحصائيات أبعاد المحتوى',
    fa: 'آمار ابعاد محتوا',
    pt: 'Estatísticas de dimensão de conteúdo'
  },
  '频道资源概况': {
    zh: '频道资源概况',
    en: 'Channel Resource Overview',
    ar: 'نظرة عامة على موارد القناة',
    fa: 'نمای کلی منابع کانال',
    pt: 'Visão geral dos recursos do canal'
  },
  '频道总数': {
    zh: '频道总数',
    en: 'Total Channels',
    ar: 'إجمالي القنوات',
    fa: 'تعداد کل کانال‌ها',
    pt: 'Total de canais'
  },
  '平台当前可用的直播频道总数': {
    zh: '平台当前可用的直播频道总数',
    en: 'Total number of live channels currently available on the platform',
    ar: 'إجمالي عدد قنوات البث المباشر المتاحة حاليًا على المنصة',
    fa: 'تعداد کل کانال‌های زنده در دسترس در پلتفرم',
    pt: 'Número total de canais ao vivo disponíveis na plataforma'
  },
  '过去3天频道利用率': {
    zh: '过去3天频道利用率',
    en: 'Channel Utilization Rate (Past 3 Days)',
    ar: 'معدل استخدام القناة (آخر 3 أيام)',
    fa: 'نرخ استفاده از کانال (3 روز گذشته)',
    pt: 'Taxa de utilização do canal (últimos 3 dias)'
  },
  '近3天有用户观看超过5分钟的频道占比': {
    zh: '近3天有用户观看超过5分钟的频道占比',
    en: 'Percentage of channels with users watching for more than 5 minutes in the past 3 days',
    ar: 'نسبة القنوات التي شاهدها المستخدمون لأكثر من 5 دقائق في آخر 3 أيام',
    fa: 'درصد کانال‌هایی که کاربران بیش از 5 دقیقه تماشا کرده‌اند در 3 روز گذشته',
    pt: 'Percentual de canais com usuários assistindo por mais de 5 minutos nos últimos 3 dias'
  },
  '近3天无用户观看或观看不足5分钟的频道占比': {
    zh: '近3天无用户观看或观看不足5分钟的频道占比',
    en: 'Percentage of channels with no users watching or watching less than 5 minutes in the past 3 days',
    ar: 'نسبة القنوات التي لم يشاهدها المستخدمون أو شاهدوها لأقل من 5 دقائق في آخر 3 أيام',
    fa: 'درصد کانال‌هایی که هیچ کاربری تماشا نکرده یا کمتر از 5 دقیقه تماشا کرده‌اند در 3 روز گذشته',
    pt: 'Percentual de canais sem usuários assistindo ou assistindo menos de 5 minutos nos últimos 3 dias'
  },
  '过去3天频道闲置率': {
    zh: '过去3天频道闲置率',
    en: 'Channel Idle Rate (Past 3 Days)',
    ar: 'معدل خمول القناة (آخر 3 أيام)',
    fa: 'نرخ بیکاری کانال (3 روز گذشته)',
    pt: 'Taxa de ociosidade do canal (últimos 3 dias)'
  },
  '实时在线人数': {
    zh: '实时在线人数',
    en: 'Online Users',
    ar: 'عدد المستخدمين المتصلين',
    fa: 'تعداد کاربران آنلاین',
    pt: 'Usuários online'
  },
  '卡顿发生频率及卡顿时长占比': {
    zh: '卡顿发生频率及卡顿时长占比',
    en: 'Frequency of stuttering and proportion of stuttering duration',
    ar: 'تكرار التوقف والتناسب في مدة التوقف',
    fa: 'فرکانس وقوع لگ و نسبت مدت زمان لگ',
    pt: 'Frequência de travamentos e proporção da duração dos travamentos'
  },
  '首帧时长': {
    zh: '首帧时长',
    en: 'First Frame Duration',
    ar: 'مدة الإطار الأول',
    fa: 'مدت زمان فریم اول',
    pt: 'Duração do primeiro quadro'
  },
  '不同首帧加载时间区间的分布比例': {
    zh: '不同首帧加载时间区间的分布比例',
    en: 'Distribution ratio of different first frame loading time intervals',
    ar: 'نسبة التوزيع لفترات زمنية مختلفة لتحميل الإطار الأول',
    fa: 'نسبت توزیع بازه‌های زمانی مختلف بارگذاری فریم اول',
    pt: 'Proporção de distribuição de diferentes intervalos de tempo de carregamento do primeiro quadro'
  },
  '首帧平均时长': {
    zh: '首帧平均时长',
    en: 'Average First Frame Duration',
    ar: 'متوسط مدة الإطار الأول',
    fa: 'میانگین مدت زمان فریم اول',
    pt: 'Duração média do primeiro quadro'
  },
  '用户从点击到看到首帧画面的平均等待时间': {
    zh: '用户从点击到看到首帧画面的平均等待时间',
    en: 'Average waiting time from user click to first frame display',
    ar: 'متوسط وقت الانتظار من نقر المستخدم إلى عرض الإطار الأول',
    fa: 'میانگین زمان انتظار از کلیک کاربر تا نمایش فریم اول',
    pt: 'Tempo médio de espera do clique do usuário até a exibição do primeiro quadro'
  },
  '平均观看时长': {
    zh: '平均观看时长',
    en: 'Average Viewing Duration',
    ar: 'متوسط مدة المشاهدة',
    fa: 'میانگین مدت زمان تماشا',
    pt: 'Duração média de visualização'
  },
  '播放码率统计': {
    zh: '播放码率统计',
    en: 'Playback Bitrate Statistics',
    ar: 'إحصائيات معدل البت للتشغيل',
    fa: 'آمار نرخ بیت پخش',
    pt: 'Estatísticas de taxa de bits de reprodução'
  },
  '指定时段内各频道各类转码率的使用情况占比': {
    zh: '指定时段内各频道各类转码率的使用情况占比',
    en: 'Proportion of usage of various transcoding rates for each channel within the specified time period',
    ar: 'نسبة استخدام معدلات التحويل المختلفة لكل قناة خلال الفترة الزمنية المحددة',
    fa: 'نسبت استفاده از نرخ‌های ترنسکد مختلف برای هر کانال در بازه زمانی مشخص شده',
    pt: 'Proporção de uso de várias taxas de transcodificação para cada canal no período de tempo especificado'
  },
  '用户互动分析': {
    zh: '用户互动分析',
    en: 'User Interaction Analysis',
    ar: 'تحليل تفاعل المستخدم',
    fa: 'تحلیل تعامل کاربر',
    pt: 'Análise de interação do usuário'
  },
  '观看时长不足5分钟离开的用户比例': {
    zh: '观看时长不足5分钟离开的用户比例',
    en: 'Proportion of users who left after watching for less than 5 minutes',
    ar: 'نسبة المستخدمين الذين غادروا بعد مشاهدة أقل من 5 دقائق',
    fa: 'نسبت کاربرانی که پس از تماشای کمتر از 5 دقیقه ترک کرده‌اند',
    pt: 'Proporção de usuários que saíram após assistir por menos de 5 minutos'
  },
  '频道切换操作的成功率': {
    zh: '频道切换操作的成功率',
    en: 'Success rate of channel switching operations',
    ar: 'معدل نجاح عمليات تبديل القناة',
    fa: 'نرخ موفقیت عملیات تعویض کانال',
    pt: 'Taxa de sucesso das operações de troca de canal'
  },
  '500毫秒内成功开播的用户比例': {
    zh: '500毫秒内成功开播的用户比例',
    en: 'Proportion of users who successfully started playback within 500ms',
    ar: 'نسبة المستخدمين الذين بدأوا التشغيل بنجاح في غضون 500 مللي ثانية',
    fa: 'نسبت کاربرانی که با موفقیت پخش را در کمتر از 500 میلی‌ثانیه شروع کرده‌اند',
    pt: 'Proporção de usuários que iniciaram a reprodução com sucesso em menos de 500ms'
  },
  '完整转码': {
    zh: '完整转码',
    en: 'Complete Transcoding',
    ar: 'التحويل الكامل',
    fa: 'ترنسکد کامل',
    pt: 'Transcodificação completa'
  },
  '支持从4K到480P完整转码频道数量及占比；各分辨率转码质量的情况': {
    zh: '支持从4K到480P完整转码频道数量及占比；各分辨率转码质量的情况',
    en: 'Number and proportion of channels supporting complete transcoding from 4K to 480P; transcoding quality for each resolution',
    ar: 'عدد ونسبة القنوات التي تدعم التحويل الكامل من 4K إلى 480P؛ جودة التحويل لكل دقة',
    fa: 'تعداد و نسبت کانال‌های پشتیبانی کننده ترنسکد کامل از 4K تا 480P؛ کیفیت ترنسکد برای هر رزولوشن',
    pt: 'Número e proporção de canais que suportam transcodificação completa de 4K a 480P; qualidade de transcodificação para cada resolução'
  },
  '完整转码频道数': {
    zh: '完整转码频道数',
    en: 'Complete Transcoding Channels',
    ar: 'عدد قنوات ترنسکد کامل',
    fa: 'املصالح شده ترنسکد کامل',
    pt: 'Canais de transcodificação completa'
  },
  '完整转码频道数率': {
    zh: '完整转码频道数率',
    en: 'Complete Transcoding Channel Rate',
    ar: 'معدل قنوات التحويل الكامل',
    fa: 'نرخ کانال‌های ترنسکد کامل',
    pt: 'Taxa de canais de transcodificação completa'
  },
  '转码分布': {
    zh: '转码分布',
    en: 'Transcoding Distribution',
    ar: 'توزيع التحويل',
    fa: 'توزیع ترنسکد',
    pt: 'Distribuição de transcodificação'
  },
  '频道切换延时': {
    zh: '频道切换延时',
    en: 'Channel Switching Delay',
    ar: 'تأخير تبديل القناة',
    fa: 'تأخیر تعویض کانال',
    pt: 'Atraso na troca de canal'
  },
  '切换频道所需的平均时间': {
    zh: '切换频道所需的平均时间',
    en: 'Average time required to switch channels',
    ar: 'متوسط الوقت المطلوب لتبديل القناة',
    fa: 'میانگین زمان مورد نیاز برای تعویض کانال',
    pt: 'Tempo médio necessário para trocar de canal'
  },
  '端到端延时': {
    zh: '端到端延时',
    en: 'End-to-End Delay',
    ar: 'التأخير من طرف إلى طرف',
    fa: 'تأخیر انتها به انتها',
    pt: 'Atraso de ponta a ponta'
  },
  '从频道采集到用户播放的整体延迟': {
    zh: '从频道采集到用户播放的整体延迟',
    en: 'Overall delay from channel collection to user playback',
    ar: 'التأخير الإجمالي من جمع القناة إلى تشغيل المستخدم',
    fa: 'تأخیر کلی از جمع‌آوری کانال تا پخش کاربر',
    pt: 'Atraso geral da coleta do canal até a reprodução do usuário'
  },
  '实时在线榜单': {
    zh: '实时在线榜单',
    en: 'Online Ranking',
    ar: 'ترتيب المتصلين',
    fa: 'رتبه‌بندی آنلاین',
    pt: 'Ranking online'
  },
  '在线观看人数前100的内容排行': {
    zh: '在线观看人数前100的内容排行',
    en: 'Top 100 content ranking by online viewers',
    ar: 'ترتيب أفضل 100 محتوى حسب عدد المشاهدين المتصلين',
    fa: 'رتبه‌بندی 100 محتوای برتر بر اساس تعداد بینندگان آنلاین',
    pt: 'Ranking dos 100 principais conteúdos por visualizadores online'
  },
  '编号': {
    zh: '编号',
    en: 'Rank',
    ar: 'الترتيب',
    fa: 'رتبه',
    pt: 'Classificação'
  },
  '数量': {
    zh: '编号',
    en: 'Number',
    ar: 'عدد',
    fa: 'تعداد',
    pt: 'Número'
  },
  '频道名称': {
    zh: '频道名称',
    en: 'Channel Name',
    ar: 'اسم القناة',
    fa: 'نام کانال',
    pt: 'Nome do canal'
  },
  '观看人数': {
    zh: '观看人数',
    en: 'Viewers',
    ar: 'عدد المشاهدين',
    fa: 'تعداد بینندگان',
    pt: 'Visualizadores'
  },
  '时间维度': {
    zh: '时间维度',
    en: 'Time Dimension',
    ar: 'البعد الزمني',
    fa: 'بعد زمانی',
    pt: 'Dimensão temporal'
  },
  '节目维度': {
    zh: '节目维度',
    en: 'Program Dimension',
    ar: 'بعد البرنامج',
    fa: 'بعد برنامه',
    pt: 'Dimensão do programa'
  },
  '500ms以下': {
    zh: '500ms以下',
    en: 'Below 500ms',
    ar: 'أقل من 500 مللي ثانية',
    fa: 'زیر 500 میلی‌ثانیه',
    pt: 'Abaixo de 500ms'
  },
  '500ms-1000ms': {
    zh: '500ms-1000ms',
    en: '500ms-1000ms',
    ar: '500-1000 مللي ثانية',
    fa: '500-1000 میلی‌ثانیه',
    pt: '500ms-1000ms'
  },
  '1000ms-1500ms': {
    zh: '1000ms-1500ms',
    en: '1000ms-1500ms',
    ar: '1000-1500 مللي ثانية',
    fa: '1000-1500 میلی‌ثانیه',
    pt: '1000ms-1500ms'
  },
  '1500ms以上': {
    zh: '1500ms以上',
    en: 'Above 1500ms',
    ar: 'أكثر من 1500 مللي ثانية',
    fa: 'بالای 1500 میلی‌ثانیه',
    pt: 'Acima de 1500ms'
  },
  '时间段': {
    zh: '时间段',
    en: 'Time Period',
    ar: 'الفترة الزمنية',
    fa: 'بازه زمانی',
    pt: 'Período de tempo'
  },
  '日期': {
    zh: '日期',
    en: 'Date',
    ar: 'التاريخ',
    fa: 'تاریخ',
    pt: 'Data'
  },
  '总体': {
    zh: '总体',
    en: 'Overall',
    ar: 'الإجمالي',
    fa: 'کلی',
    pt: 'Geral'
  },
  '次': {
    zh: '次',
    en: 'times',
    ar: 'مرات',
    fa: 'بار',
    pt: 'vezes'
  },
  '付费设置': {
    zh: '付费设置',
    en: 'Paid Setting',
    ar: 'إعدادات الدفع',
    fa: 'تنظیمات الدفع',
    pt: 'Configurações de Pagamento'
  },
  '付费节目': {
    zh: '付费节目',
    en: 'Paid Program',
    ar: 'برنامج دفع',
    fa: 'برنامج دفع',
    pt: 'Programa de Pagamento'
  },
  '请选择是否付费': {
    zh: '请选择是否付费',
    en: 'Please select whether to pay',
    ar: 'يرجى تحديد ما إذا كنت تريد دفعها',
    fa: 'لطفا انتخاب کنید که آیا می‌خواهید دفعها',
    pt: 'Por favor, selecione se você deseja pagar'
  },
  '付费': {
    zh: '付费',
    en: 'Paid',
    ar: 'دفع',
    fa: 'دفع',
    pt: 'Pago'
  },
  '免费节目': {
    zh: '免费节目',
    en: 'Free Content',
    ar: 'محتوى مجاني',
    fa: 'محتوای رایگان',
    pt: 'Conteúdo Gratuito'
  },
  'VIP1: 非VIP限制分辨率': {
    zh: 'VIP1: 非VIP限制分辨率',
    en: 'VIP1: Non-VIP Resolution Restricted',
    ar: 'VIP1: جودة الصورة محدودة لغير الأعضاء',
    fa: 'VIP1: محدودیت رزولوشن برای غیر VIP',
    pt: 'VIP1: Resolução Restrita para Não-VIP'
  },
  'VIP2: 非VIP禁止观看': {
    zh: 'VIP2: 非VIP禁止观看',
    en: 'VIP2: Non-VIP Viewing Prohibited',
    ar: 'VIP2: ممنوع المشاهدة لغير الأعضاء',
    fa: 'VIP2: تماشا ممنوع برای غیر VIP',
    pt: 'VIP2: Visualização Proibida para Não-VIP'
  },
  '获取节目详情': {
    zh: '获取节目详情',
    en: 'Get Program Details',
    ar: 'الحصول على تفاصيل البرنامج',
    fa: 'دریافت جزئیات برنامه',
    pt: 'Obter detalhes do programa'
  },
  '导入信息源ID': {
    zh: '导入信息源ID',
    en: 'Import source ID',
    ar: 'استيراد معرّف المصدر',
    fa: 'وارد کردن شناسه منبع',
    pt: 'Importar ID da fonte'
  },
  '请导入信息源ID': {
    zh: '请导入信息源ID',
    en: 'Please import the source ID',
    ar: 'يرجى استيراد معرّف المصدر',
    fa: 'لطفاً شناسه منبع را وارد کنید',
    pt: 'Por favor, importe o ID da fonte'
  },
  '去水印位置': {
    zh: '去水印位置',
    en: 'De-logo position',
    ar: 'موضع إزالة الشعار',
    fa: 'موقع حذف واترمارک',
    pt: 'Posição de remoção de marca-d’água',
  },
  '去水印宽高': {
    zh: '去水印宽高',
    en: 'De-logo size',
    ar: 'أبعاد إزالة الشعار',
    fa: 'ابعاد حذف واترمارک',
    pt: 'Tamanho de remoção de marca-d’água',
  },
  '广告裁剪开始时间': {
    zh: '广告裁剪开始时间',
    en: 'Crop Start Time',
    ar: 'وقت بدء الاقتصاص',
    fa: 'زمان شروع برش',
    pt: 'Tempo de Início de Corte',
  },
  '广告裁剪结束时间': {
    zh: '广告裁剪结束时间',
    en: 'Crop End Time',
    ar: 'وقت نهاية الاقتصاص',
    fa: 'زمان پایان برش',
    pt: 'Tempo de Fim de Corte',
  },
  '是否是系列片': {
    zh: '是否是系列片',
    en: 'Movie Sets',
    ar: 'مسلسل',
    fa: 'فیلم سری',
    pt: 'Series'
  },
  '请选择内容类型': {
    zh: '请选择内容类型',
    en: 'Please select content Category',
    ar: 'يرجى اختيار نوع المحتوى',
    fa: 'لطفا نوع محتوا را انتخاب کنید',
    pt: 'Selecione o tipo de conteudo',
  },
  '内容分类': {
    zh: '内容分类',
    en: 'Content Category',
    ar: 'تصنيف المحتوى',
    fa: 'دسته بندي محتوا',
    pt: 'Categoria de conteudo',
  },
  '硬编码': {
    zh: '硬编码',
    en: 'Encoding',
    ar: 'تشفير',
    fa: 'رمزگذاری',
    pt: 'Codificação',
  },
  '关联品牌': {
    zh: '关联品牌',
    en: 'Associated Brand',
    ar: 'العلامة التجارية المرتبطة',
    fa: 'برند مرتبط',
    pt: 'Marca associada',
  },
  '关联方案': {
    zh: '关联方案',
    en: 'Associated Plan',
    ar: 'الخطة المرتبطة',
    fa: 'طرح مرتبط',
    pt: 'Plano associado',
  },
  '主题已关联方案，修改主题将同步变更关联的方案，确定修改？': {
    zh: '主题已关联方案，修改主题将同步变更关联的方案，确定修改？',
    en: 'The topic is associated with a plan. Modifying the topic will synchronously change the associated plan. Confirm the modification?',
    ar: 'الموضوع مرتبط بخطة، وتعديل الموضوع سيغير الخطة المرتبطة به بشكل متزامن. هل تؤكد التعديل؟',
    fa: 'موضوع با یک طرح مرتبط است، تغییر موضوع طرح مرتبط را همزمان تغییر می‌دهد. آیا تغییر را تأیید می‌کنید؟',
    pt: 'O tópico está associado a um plano. Modificar o tópico alterará simultaneamente o plano associado. Confirmar a modificação?',
  },
  '方案已关联品牌，修改方案将同步变更关联的品牌，确定修改？': {
  zh: '方案已关联品牌，修改方案将同步变更关联的品牌，确定修改？',
  en: 'The plan is already associated with a brand. Modifying the plan will synchronize changes to the associated brand. Confirm the modification?',
  ar: 'الخطة مرتبطة بالفعل بعلامة تجارية، وتعديل الخطة سيؤدي إلى مزامنة التغييرات مع العلامة التجارية المرتبطة. هل تريد تأكيد التعديل؟',
  fa: 'طرح از قبل به یک برند مرتبط شده است، تغییر طرح باعث همگام‌سازی تغییرات با برند مرتبط می‌شود. آیا تغییر را تأیید می‌کنید؟',
  pt: 'O plano já está associado a uma marca. Modificar o plano sincronizará as alterações com a marca associada. Confirmar a modificação?',
},

  '帧率': {
    zh: '帧率',
    en: 'Frame Rate',
    ar: 'معدل الإطارات',
    fa: 'نرخ فریم',
    pt: 'Taxa de quadros',
  },
  '请输入Http Headers': {
    zh: '请输入Http Headers',
    en: 'Please enter HTTP Headers',
    ar: 'يرجى إدخال رؤوس HTTP',
    fa: 'لطفاً سرآیندهای HTTP را وارد کنید',
    pt: 'Insira os cabeçalhos HTTP',
  },
  '是否黑名单': {
  zh: '是否黑名单',
  en: 'Is Black',
  ar: 'هل هو في القائمة السوداء',
  fa: 'آیا در لیست سیاه است',
  pt: 'Está na lista negra',
},
  '分发策略': {
    zh: '分发策略',
    en: 'Distribution Strategy',
    ar: 'استراتيجية التوزيع',
    fa: 'استراتژی توزیع',
    pt: 'Estratégia de distribuição',
  },
  'VPN访问': {
    zh: 'VPN访问',
    en: 'VPN Access',
    ar: 'الوصول عبر VPN',
    fa: 'دسترسی VPN',
    pt: 'Acesso VPN',
  },
  '黑名单访问': {
    zh: '黑名单访问',
    en: 'Blacklist Access',
    ar: 'الوصول عبر القائمة السوداء',
    fa: 'دسترسی لیست سیاه',
    pt: 'Acesso à lista negra',
  },
  '请选择分发策略': {
    zh: '请选择分发策略',
    en: 'Please select distribution strategy',
    ar: 'يرجى اختيار استراتيجية التوزيع',
    fa: 'لطفاً استراتژی توزیع را انتخاب کنید',
    pt: 'Selecione a estratégia de distribuição',
  },
  '处置域名配置': {
    zh: '处置域名配置',
    en: 'Domain Config',
    ar: 'إعداد النطاق',
    fa: 'تنظیم دامنه',
    pt: 'Config. de Domínio',
  },
  '批量操作': {
    zh: '批量操作',
    en: 'Batch Operation',
    ar: 'إجراء جماعي',
    fa: 'عملیات گروهی',
    pt: 'Operação em Lote',
  },
  '批量删除': {
    zh: '批量删除',
    en: 'Batch Delete',
    ar: 'حذف جماعي',
    fa: 'حذف گروهی',
    pt: 'Excluir em Lote',
  },
  '批量配置': {
    zh: '批量配置',
    en: 'Batch Configuration',
    ar: 'إعداد جماعي',
    fa: 'پیکربندی گروهی',
    pt: 'Configuração em Lote',
  },
  '请先勾选需要删除的数据': {
    zh: '请先勾选需要删除的数据',
    en: 'Please select the data to delete first',
    ar: 'يرجى تحديد البيانات المراد حذفها أولاً',
    fa: 'لطفاً ابتدا داده‌های مورد حذف را انتخاب کنید',
    pt: 'Selecione primeiro os dados a serem excluídos',
  },
  '未获取到可删除的数据': {
    zh: '未获取到可删除的数据',
    en: 'No deletable data was found',
    ar: 'لم يتم العثور على بيانات قابلة للحذف',
    fa: 'داده قابل حذفی یافت نشد',
    pt: 'Nenhum dado disponível para exclusão foi encontrado',
  },
  '确定删除已选数据吗?': {
    zh: '确定删除已选数据吗?',
    en: 'Confirm deleting the selected data?',
    ar: 'هل تؤكد حذف البيانات المحددة؟',
    fa: 'از حذف داده‌های انتخاب‌شده مطمئن هستید؟',
    pt: 'Confirmar a exclusão dos dados selecionados?',
  },
  '请先勾选需要配置的数据': {
    zh: '请先勾选需要配置的数据',
    en: 'Please select the data to configure first',
    ar: 'يرجى تحديد البيانات المراد إعدادها أولاً',
    fa: 'لطفاً ابتدا داده‌های مورد پیکربندی را انتخاب کنید',
    pt: 'Selecione primeiro os dados a serem configurados',
  },
  '未获取到可配置的数据': {
    zh: '未获取到可配置的数据',
    en: 'No configurable data was found',
    ar: 'لم يتم العثور على بيانات قابلة للإعداد',
    fa: 'داده قابل پیکربندی یافت نشد',
    pt: 'Nenhum dado configurável foi encontrado',
  },
  '请至少填写一个需要配置的字段': {
    zh: '请至少填写一个需要配置的字段',
    en: 'Please complete at least one field to configure',
    ar: 'يرجى تعبئة حقل واحد على الأقل للإعداد',
    fa: 'لطفاً حداقل یک فیلد برای پیکربندی تکمیل کنید',
    pt: 'Preencha pelo menos um campo para configurar',
  },
  '下发配置': {
    zh: '下发配置',
    en: 'Dispatch',
    ar: 'توزيع',
    fa: 'ارسال',
    pt: 'Distribuir',
  },
  '下发历史': {
    zh: '下发历史',
    en: 'Dispatch History',
    ar: 'سجل التوزيع',
    fa: 'تاریخچه ارسال',
    pt: 'Histórico de Distribuição',
  },
  '下发时间': {
    zh: '下发时间',
    en: 'Dispatch Time',
    ar: 'وقت التوزيع',
    fa: 'زمان ارسال',
    pt: 'Hora de Distribuição',
  },
  '处置方式': {
    zh: '处置方式',
    en: 'Disposal Method',
    ar: 'طريقة المعالجة',
    fa: 'روش اقدام',
    pt: 'Método de Tratamento',
  },
  '处置域名': {
    zh: '处置域名',
    en: 'Disposal Domain',
    ar: 'نطاق المعالجة',
    fa: 'دامنه اقدام',
    pt: 'Domínio de Tratamento',
  },
  'AD 编号/名称': {
    zh: 'AD 编号/名称',
    en: 'AD ID/Name',
    ar: 'معرف/اسم AD',
    fa: 'شناسه/نام AD',
    pt: 'ID/Nome do AD',
  },
  '节目识别码': {
    zh: '节目识别码',
    en: 'Program Identifier',
    ar: 'معرف البرنامج',
    fa: 'شناسه برنامه',
    pt: 'Identificador do Programa',
  },
  '对应域名': {
    zh: '对应域名',
    en: 'Corresponding Domain',
    ar: 'النطاق المقابل',
    fa: 'دامنه متناظر',
    pt: 'Domínio Correspondente',
  },
  '请先勾选需要下发的数据': {
    zh: '请先勾选需要下发的数据',
    en: 'Please select the data to dispatch first',
    ar: 'يرجى تحديد البيانات المراد توزيعها أولاً',
    fa: 'لطفاً ابتدا داده‌های مورد ارسال را انتخاب کنید',
    pt: 'Selecione primeiro os dados a serem distribuídos',
  },
  '未获取到可下发的数据': {
    zh: '未获取到可下发的数据',
    en: 'No dispatchable data was found',
    ar: 'لم يتم العثور على بيانات قابلة للتوزيع',
    fa: 'داده قابل ارسالی یافت نشد',
    pt: 'Nenhum dado disponível para distribuição foi encontrado',
  },
  '确定下发已选数据吗?': {
    zh: '确定下发已选数据吗?',
    en: 'Confirm dispatching the selected data?',
    ar: 'هل تؤكد توزيع البيانات المحددة؟',
    fa: 'از ارسال داده‌های انتخاب‌شده مطمئن هستید؟',
    pt: 'Confirmar a distribuição dos dados selecionados?',
  },
  '请完整填写正确的处置域名配置': {
    zh: '请完整填写正确的处置域名配置',
    en: 'Please complete the disposal domain configuration correctly',
    ar: 'يرجى إكمال إعدادات نطاق المعالجة بشكل صحيح',
    fa: 'لطفاً پیکربندی دامنه اقدام را به‌درستی تکمیل کنید',
    pt: 'Preencha corretamente a configuração de domínio de tratamento',
  },

  '新增规则': {
    zh: '新增规则',
    en: 'Add Rule',
    ar: 'إضافة قاعدة',
    fa: 'افزودن قانون',
    pt: 'Adicionar Regra',
  },
  '周期插播广告': {
    zh: '周期插播广告',
    en: 'Periodic Ad Insertion',
    ar: 'إدراج إعلان دوري',
    fa: 'درج دوره‌ای تبلیغ',
    pt: 'Inserção Periódica de Anúncios',
  },
  '纯广告流': {
    zh: '纯广告流',
    en: 'Ad-only Stream',
    ar: 'تدفق إعلاني فقط',
    fa: 'جریان فقط تبلیغ',
    pt: 'Fluxo Somente de Anúncios',
  },
  '成人内容': {
    zh: '成人内容',
    en: 'Adult Content',
    ar: 'محتوى للبالغين',
    fa: 'محتوای بزرگسالان',
    pt: 'Conteúdo Adulto',
  },
  'H.264域名': {
    zh: 'H.264域名',
    en: 'H.264 Domain',
    ar: 'نطاق H.264',
    fa: 'دامنه H.264',
    pt: 'Domínio H.264',
  },
  'H.265域名': {
    zh: 'H.265域名',
    en: 'H.265 Domain',
    ar: 'نطاق H.265',
    fa: 'دامنه H.265',
    pt: 'Domínio H.265',
  },
  '有效时间段': {
    zh: '有效时间段',
    en: 'Effective Time Range',
    ar: 'الفترة الزمنية الفعالة',
    fa: 'بازه زمانی مؤثر',
    pt: 'Período Efetivo',
  },
  '每播放10分钟节目后插播10分钟广告': {
    zh: '每播放10分钟节目后插播10分钟广告',
    en: 'Insert 10 minutes of ads after every 10 minutes of programming',
    ar: 'إدراج 10 دقائق من الإعلانات بعد كل 10 دقائق من البرامج',
    fa: 'پس از هر ۱۰ دقیقه برنامه، ۱۰ دقیقه تبلیغ پخش می‌شود',
    pt: 'Insere 10 minutos de anúncios após cada 10 minutos de programação',
  },
  '整个流只播放广告': {
    zh: '整个流只播放广告',
    en: 'The entire stream plays ads only',
    ar: 'يبث التدفق بالكامل إعلانات فقط',
    fa: 'کل جریان فقط تبلیغ پخش می‌کند',
    pt: 'Todo o fluxo reproduz apenas anúncios',
  },
  '有效时间段内播放成人内容，其他时间执行周期插播广告': {
    zh: '有效时间段内播放成人内容，其他时间执行周期插播广告',
    en: 'Play adult content during the effective period; otherwise use periodic ad insertion',
    ar: 'تشغيل محتوى البالغين خلال الفترة الفعالة، وإدراج الإعلانات دورياً في الأوقات الأخرى',
    fa: 'در بازه مؤثر محتوای بزرگسالان پخش می‌شود و در سایر زمان‌ها تبلیغ دوره‌ای اجرا می‌شود',
    pt: 'Reproduz conteúdo adulto no período efetivo; nos demais horários usa inserção periódica de anúncios',
  },
  '请完整填写正确的规则信息': {
    zh: '请完整填写正确的规则信息',
    en: 'Please complete the rule information correctly',
    ar: 'يرجى إكمال معلومات القاعدة بشكل صحيح',
    fa: 'لطفاً اطلاعات قانون را به‌درستی تکمیل کنید',
    pt: 'Preencha corretamente as informações da regra',
  },

  '禁止播放': {
    zh: '禁止播放',
    en: 'Block Playback',
    ar: 'منع التشغيل',
    fa: 'مسدود کردن پخش',
    pt: 'Bloquear Reprodução',
  },
  '禁止登录': {
    zh: '禁止登录',
    en: 'Block Login',
    ar: 'منع تسجيل الدخول',
    fa: 'مسدود کردن ورود',
    pt: 'Bloquear Login',
  },
  '成人内容需要填该字段': {
    zh: '成人内容需要填该字段',
    en: 'Adult content requires this field',
    ar: 'يتطلب محتوى البالغين هذا الحقل',
    fa: 'محتوای بزرگسالان به این فیلد نیاز دارد',
    pt: 'Conteúdo adulto requer este campo',
  },
  '开始时间': {
    zh: '开始时间',
    en: 'Start Time',
    ar: 'وقت البدء',
    fa: 'زمان شروع',
    pt: 'Hora de Início',
  },
  '结束时间': {
    zh: '结束时间',
    en: 'End Time',
    ar: 'وقت الانتهاء',
    fa: 'زمان پایان',
    pt: 'Hora de Término',
  },

  'H.264域名和H.265域名不能相同': {
    zh: 'H.264域名和H.265域名不能相同',
    en: 'H.264 and H.265 domains cannot be the same',
    ar: 'لا يمكن أن يكون نطاقا H.264 وH.265 متطابقين',
    fa: 'دامنه‌های H.264 و H.265 نمی‌توانند یکسان باشند',
    pt: 'Os domínios H.264 e H.265 não podem ser iguais',
  },

  '请选择类型': {
    zh: '请选择类型', en: 'Please select a type', ar: 'يرجى اختيار النوع', fa: 'لطفاً نوع را انتخاب کنید', pt: 'Selecione um tipo'
  },
  '请输入AD编号': {
    zh: '请输入AD编号', en: 'Please enter the AD ID', ar: 'يرجى إدخال معرف AD', fa: 'لطفاً شناسه AD را وارد کنید', pt: 'Insira o ID do AD'
  },
  'AD编号不能为block': {
    zh: 'AD编号不能为block', en: 'The AD ID cannot be block', ar: 'لا يمكن أن يكون معرف AD هو block', fa: 'شناسه AD نمی‌تواند block باشد', pt: 'O ID do AD não pode ser block'
  },
  'AD编号不能包含英文逗号': {
    zh: 'AD编号不能包含英文逗号', en: 'The AD ID cannot contain commas', ar: 'لا يمكن أن يحتوي معرف AD على فواصل', fa: 'شناسه AD نمی‌تواند شامل ویرگول انگلیسی باشد', pt: 'O ID do AD não pode conter vírgulas'
  },
  'AD编号不能重复': {
    zh: 'AD编号不能重复', en: 'The AD ID cannot be duplicated', ar: 'لا يمكن تكرار معرف AD', fa: 'شناسه AD نمی‌تواند تکراری باشد', pt: 'O ID do AD não pode ser duplicado'
  },
  '请输入节目识别码': {
    zh: '请输入节目识别码', en: 'Please enter the program identifier', ar: 'يرجى إدخال معرف البرنامج', fa: 'لطفاً شناسه برنامه را وارد کنید', pt: 'Insira o identificador do programa'
  },
  '请输入H.264域名': {
    zh: '请输入H.264域名', en: 'Please enter the H.264 domain', ar: 'يرجى إدخال نطاق H.264', fa: 'لطفاً دامنه H.264 را وارد کنید', pt: 'Insira o domínio H.264'
  },
  '请输入H.265域名': {
    zh: '请输入H.265域名', en: 'Please enter the H.265 domain', ar: 'يرجى إدخال نطاق H.265', fa: 'لطفاً دامنه H.265 را وارد کنید', pt: 'Insira o domínio H.265'
  },
  'H.264域名格式不正确': {
    zh: 'H.264域名格式不正确', en: 'The H.264 domain format is invalid', ar: 'تنسيق نطاق H.264 غير صحيح', fa: 'قالب دامنه H.264 صحیح نیست', pt: 'O formato do domínio H.264 é inválido'
  },
  'H.265域名格式不正确': {
    zh: 'H.265域名格式不正确', en: 'The H.265 domain format is invalid', ar: 'تنسيق نطاق H.265 غير صحيح', fa: 'قالب دامنه H.265 صحیح نیست', pt: 'O formato do domínio H.265 é inválido'
  },
  '成人内容请填写有效时间段': {
    zh: '成人内容请填写有效时间段', en: 'Please set an effective time range for adult content', ar: 'يرجى تعيين فترة زمنية فعالة لمحتوى البالغين', fa: 'لطفاً برای محتوای بزرگسالان بازه زمانی مؤثر تعیین کنید', pt: 'Defina um período efetivo para conteúdo adulto'
  },
  '有效时间段开始时间必须大于当前时间': {
    zh: '有效时间段开始时间必须大于当前时间', en: 'The effective start time must be later than the current time', ar: 'يجب أن يكون وقت البدء الفعال بعد الوقت الحالي', fa: 'زمان شروع بازه مؤثر باید بعد از زمان فعلی باشد', pt: 'O horário inicial do período efetivo deve ser posterior ao horário atual'
  },
  '有效时间段开始时间必须早于结束时间': {
    zh: '有效时间段开始时间必须早于结束时间', en: 'The effective start time must be earlier than the end time', ar: 'يجب أن يكون وقت البدء الفعال قبل وقت الانتهاء', fa: 'زمان شروع بازه مؤثر باید قبل از زمان پایان باشد', pt: 'O horário inicial do período efetivo deve ser anterior ao horário final'
  },

  '节目识别码不能重复': {
    zh: '节目识别码不能重复', en: 'The program identifier cannot be duplicated', ar: 'لا يمكن تكرار معرف البرنامج', fa: 'شناسه برنامه نمی‌تواند تکراری باشد', pt: 'O identificador do programa não pode ser duplicado'
  },

  'AD 编号': {
    zh: 'AD 编号',
    en: 'AD ID',
    ar: 'معرف AD',
    fa: 'شناسه AD',
    pt: 'ID do AD',
  },

  // '新增': {
  //   zh: '新增',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: '',
  // },

  // Sat-to-IP 分组及频道管理文案
  '节目分组': {
    zh: '节目分组', en: 'Program Groups', ar: 'مجموعات البرامج', fa: 'گروه‌های برنامه', pt: 'Grupos de programas'
  },
  '频道名称、频道识别码': {
    zh: '频道名称、频道识别码', en: 'Channel name or callsign', ar: 'اسم القناة أو معرف القناة', fa: 'نام یا شناسه کانال', pt: 'Nome ou identificador do canal'
  },
  '频道列表': {
    zh: '频道列表', en: 'Channel List', ar: 'قائمة القنوات', fa: 'فهرست کانال‌ها', pt: 'Lista de canais'
  },
  '按品牌分类': {
    zh: '按品牌分类', en: 'By Brand Category', ar: 'حسب فئة العلامة التجارية', fa: 'بر اساس دسته‌بندی برند', pt: 'Por categoria de marca'
  },
  '按频道添加': {
    zh: '按频道添加', en: 'Add by Channel', ar: 'إضافة حسب القناة', fa: 'افزودن بر اساس کانال', pt: 'Adicionar por canal'
  },
  '品牌分类添加频道': {
    zh: '品牌分类添加频道', en: 'Add Channels by Brand Category', ar: 'إضافة القنوات حسب فئة العلامة التجارية', fa: 'افزودن کانال‌ها بر اساس دسته‌بندی برند', pt: 'Adicionar canais por categoria de marca'
  },
  '请选择添加方式': {
    zh: '请选择添加方式', en: 'Please select an adding method', ar: 'يرجى اختيار طريقة الإضافة', fa: 'لطفاً روش افزودن را انتخاب کنید', pt: 'Selecione um método de adição'
  },
  '按子品牌分类': {
    zh: '按子品牌分类', en: 'By Sub-brand Category', ar: 'حسب فئة العلامة التجارية الفرعية', fa: 'بر اساس دسته‌بندی زیربرند', pt: 'Por categoria de submarca'
  },
  '按频道': {
    zh: '按频道', en: 'By Channel', ar: 'حسب القناة', fa: 'بر اساس کانال', pt: 'Por canal'
  },
  'Sat2Ip节目': {
    zh: 'Sat2Ip节目', en: 'Sat2IP Programs', ar: 'برامج Sat2IP', fa: 'برنامه‌های Sat2IP', pt: 'Programas Sat2IP'
  },
  '创建并前往选择频道 ›': {
    zh: '创建并前往选择频道 ›', en: 'Create and select channels ›', ar: 'إنشاء والانتقال لاختيار القنوات ›', fa: 'ایجاد و رفتن به انتخاب کانال ›', pt: 'Criar e selecionar canais ›'
  },
  '分组名称': {
    zh: '分组名称', en: 'Group Name', ar: 'اسم المجموعة', fa: 'نام گروه', pt: 'Nome do grupo'
  },
  '分组名称不能超过50个字符': {
    zh: '分组名称不能超过50个字符', en: 'The group name cannot exceed 50 characters', ar: 'لا يمكن أن يتجاوز اسم المجموعة 50 حرفًا', fa: 'نام گروه نمی‌تواند بیشتر از ۵۰ نویسه باشد', pt: 'O nome do grupo não pode exceder 50 caracteres'
  },
  '请先创建并选择一个分组': {
    zh: '请先创建并选择一个分组', en: 'Please create and select a group first', ar: 'يرجى إنشاء مجموعة واختيارها أولاً', fa: 'لطفاً ابتدا یک گروه ایجاد و انتخاب کنید', pt: 'Crie e selecione um grupo primeiro'
  },
  '分组创建成功': {
    zh: '分组创建成功', en: 'Group created successfully', ar: 'تم إنشاء المجموعة بنجاح', fa: 'گروه با موفقیت ایجاد شد', pt: 'Grupo criado com sucesso'
  },
  '分组创建成功，但未找到新分组': {
    zh: '分组创建成功，但未找到新分组', en: 'The group was created, but the new group could not be found', ar: 'تم إنشاء المجموعة، ولكن تعذر العثور على المجموعة الجديدة', fa: 'گروه ایجاد شد، اما گروه جدید پیدا نشد', pt: 'O grupo foi criado, mas não foi possível encontrá-lo'
  },
  '移除确认': {
    zh: '移除确认', en: 'Remove Confirmation', ar: 'تأكيد الإزالة', fa: 'تأیید حذف', pt: 'Confirmação de remoção'
  },
  '确定移除该频道吗？': {
    zh: '确定移除该频道吗？', en: 'Are you sure you want to remove this channel?', ar: 'هل أنت متأكد من إزالة هذه القناة؟', fa: 'آیا از حذف این کانال مطمئن هستید؟', pt: 'Tem certeza de que deseja remover este canal?'
  },
  '确定移除所选频道吗？': {
    zh: '确定移除所选频道吗？', en: 'Are you sure you want to remove the selected channels?', ar: 'هل أنت متأكد من إزالة القنوات المحددة؟', fa: 'آیا از حذف کانال‌های انتخاب‌شده مطمئن هستید؟', pt: 'Tem certeza de que deseja remover os canais selecionados?'
  },
  '所选频道缺少有效ID': {
    zh: '所选频道缺少有效ID', en: 'The selected channel has no valid ID', ar: 'القناة المحددة لا تحتوي على معرف صالح', fa: 'کانال انتخاب‌شده شناسه معتبری ندارد', pt: 'O canal selecionado não possui um ID válido'
  },
  '频道添加成功': {
    zh: '频道添加成功', en: 'Channels added successfully', ar: 'تمت إضافة القنوات بنجاح', fa: 'کانال‌ها با موفقیت اضافه شدند', pt: 'Canais adicionados com sucesso'
  },
  '频道添加成功，新增{added}个，跳过{skipped}个': {
    zh: '频道添加成功，新增{added}个，跳过{skipped}个', en: 'Channels added successfully: {added} added, {skipped} skipped', ar: 'تمت إضافة القنوات: تمت إضافة {added} وتخطي {skipped}', fa: 'کانال‌ها با موفقیت اضافه شدند: {added} مورد اضافه و {skipped} مورد رد شد', pt: 'Canais adicionados: {added} adicionados e {skipped} ignorados'
  },
  '设备品牌': {
    zh: '设备品牌', en: 'Device Brand', ar: 'العلامة التجارية للجهاز', fa: 'برند دستگاه', pt: 'Marca do dispositivo'
  },
  '请选择设备品牌': {
    zh: '请选择设备品牌', en: 'Please select a device brand', ar: 'يرجى اختيار العلامة التجارية للجهاز', fa: 'لطفاً برند دستگاه را انتخاب کنید', pt: 'Selecione uma marca de dispositivo'
  },
  '设备平台': {
    zh: '设备平台', en: 'Device Platform', ar: 'منصة الجهاز', fa: 'پلتفرم دستگاه', pt: 'Plataforma do dispositivo'
  },
  '请选择设备平台': {
    zh: '请选择设备平台', en: 'Please select a device platform', ar: 'يرجى اختيار منصة الجهاز', fa: 'لطفاً پلتفرم دستگاه را انتخاب کنید', pt: 'Selecione uma plataforma de dispositivo'
  },
  '设备型号': {
    zh: '设备型号', en: 'Device Model', ar: 'طراز الجهاز', fa: 'مدل دستگاه', pt: 'Modelo do dispositivo'
  },
  '请选择设备型号': {
    zh: '请选择设备型号', en: 'Please select a device model', ar: 'يرجى اختيار طراز الجهاز', fa: 'لطفاً مدل دستگاه را انتخاب کنید', pt: 'Selecione um modelo de dispositivo'
  }

}